// import CustomSearchDropdown from "../POP/FileComp5";
// import React, { useState, useEffect, useCallback } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { API_BASE_URL } from "../../Config/Config";
// import YellowPlus from "../../Assets/Images/CommanImages/YellowPlus.png";
// import _ from "lodash";
// import ThreeDots from "../../Assets/Images/CommanImages/ThreeDotsVertical.png";
// const mapDataToDropdownFormat = (dataArray, idField, nameField) => {
//   return _.uniqBy(
//     dataArray.map((item) => ({
//       id: item[idField],
//       label: item[nameField],
//     })),
//     "id"
//   );
// };
// const POP2 = () => {
//   const dispatch = useDispatch();
//   const { coursesdata } = useSelector((state) => state.course);
//   const [selectedType, setSelectedType] = useState("single-select");
//   const [resultsData, setResultsData] = useState([]);
//   const [testnamedata, setTestNameData] = useState([]);
//   const [resetKey, setResetKey] = useState(0);
//   const [selectedBatchName, setSelectedBatchName] = useState("");
//   const [testname, setTestName] = useState([]);
//   const [chapterName, setChapterName] = useState([]);
//   const [filteredSubjects, setFilteredSubjects] = useState([]);
//   const [filteredBatches, setFilteredBatches] = useState([]);
//   const [apiData, setApiData] = useState([]);
//   const [batchData, setBatchData] = useState([]);
//   const [subjectData, setSubjectData] = useState([]);
//   const [chapterData, setChapterData] = useState([]);
//   const [dppData, setDppData] = useState([]);
//   const [studentData, setStudentData] = useState([]);
//   const [selectedCourseId, setSelectedCourseId] = useState(" ");
//   const [selectedChapters, setSelectedChapters] = useState([]);
//   const [selectedDppIds, setSelectedDppIds] = useState([]);
//   const [selectedBatches, setSelectedBatches] = useState([]);
//   const [selectedSubjects, setSelectedSubjects] = useState([]);
//   const [selectedStudents, setSelectedStudents] = useState([]);
//   const [searchKey, setSearchKey] = useState("");
//   const [searchColumn, setSearchColumn] = useState("");
//   const [isClicked, setIsClicked] = useState(false);

//   const handleTypeChange = (event) => {
//     setSelectedType(event.target.value);
//   };

//   const handleDropdownClose = () => {
//     fetchDropdownData();
//   };
//   const fetchDropdownData = useCallback(async () => {
//     try {
//       if (!selectedCourseId) throw new Error("No course selected");

//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-dpp-report-filter-searchkey-v2/?course_id=${selectedCourseId}`,
//         {
//           method: "POST",
//           headers: {
//             accept: "application/json",
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             batch_ids: selectedBatches,
//             subject_ids: selectedSubjects,
//             chapter_ids: selectedChapters,
//             assessment_ids: selectedDppIds,
//             student_ids: selectedStudents,
//             search_key: searchKey,
//             search_column: searchColumn,
//           }),
//         }
//       );
//       const data = await response.json();

//       setBatchData(
//         mapDataToDropdownFormat(data.batch_list, "batch_id", "batch_name")
//       );
//       setSubjectData(
//         mapDataToDropdownFormat(data.subject_list, "subject_id", "subject_name")
//       );
//       const uniqueChapters = _.uniqBy(data.chapter_list, "chapter_id");
//       setChapterData(
//         uniqueChapters.map((item) => ({
//           id: item.chapter_id,
//           chapter_name: item.chapter_name, // Field for Chapter Name
//           subject_name: item.subject_name, // Field for Subject Name
//           // batch_name: item.batch_name, // Field for Batch Name
//         }))
//       );
//       const uniqueAssessments = _.uniqBy(
//         data.assessment_list.filter(
//           (assessment) => assessment.assessment_type_id === 1
//         ),
//         "assessment_id"
//       );

//       setDppData(
//         uniqueAssessments.map((item) => ({
//           id: item.assessment_id,
//           assessment_name: item.assessment_name,
//           chapter_name: item.chapter_name,
//           subject_name: item.subject_name,
//         }))
//       );

//       setStudentData(
//         mapDataToDropdownFormat(data.student_list, "student_id", "student_name")
//       );
//     } catch (error) {
//       console.error("Error fetching dropdown data:", error);
//     }
//   }, [
//     selectedCourseId,
//     selectedBatches,
//     selectedSubjects,
//     selectedChapters,
//     selectedDppIds,
//     selectedStudents,
//     searchKey,
//     searchColumn,
//   ]);
//   return (
//     <>
//       {" "}
//       <h2 style={{ paddingLeft: "35px" }}>Add Question</h2>
//       <div style={{ paddingLeft: "35px", paddingTop: "15px" }}>
//         <div
//           style={{
//             width: "82vw",
//             height: "30px",
//             fontWeight: "600",
//             backgroundColor: "#D6D6D6",
//             alignContent: "center",
//             paddingLeft: "8px",
//             boxShadow: "4px 4px 4px 0px #00000040",
//             border: "1px solid lightgrey",
//           }}
//         >
//           <p style={{ color: "#424342" }}>QUESTION TAGGING</p>
//           {/* <p>-</p> */}
//         </div>
//         <div
//           style={{
//             backgroundColor: "#FBFBFB",
//             width: "82vw",
//             boxShadow: "4px 4px 4px 0px #00000040",
//             color: "#424342",
//             padding: "10px",
//             border: "1px solid lightgrey",
//           }}
//         >
//           {" "}
//           <CustomSearchDropdown
//             label="Select Course"
//             optionsData={chapterData}
//             selected={selectedChapters}
//             setSelected={setSelectedChapters}
//             placeholder="Search for Course..."
//             headers={["Chapter Name", "Subject Name"]}
//             optionFields={{
//               option1: "chapter_name",
//               option2: "subject_name",
//             }}
//             onDropdownClose={handleDropdownClose} // API call after dropdown closes
//             customwidth="20vw"
//           />{" "}
//           <CustomSearchDropdown
//             label="Select DPP"
//             optionsData={chapterData}
//             selected={selectedChapters}
//             setSelected={setSelectedChapters}
//             placeholder="Search for DPP..."
//             headers={["Chapter Name", "Subject Name"]}
//             optionFields={{
//               option1: "chapter_name",
//               option2: "subject_name",
//             }}
//             onDropdownClose={handleDropdownClose}
//             customwidth="20vw"
//           />{" "}
//           <CustomSearchDropdown
//             label="Select Chapter"
//             optionsData={chapterData}
//             selected={selectedChapters}
//             setSelected={setSelectedChapters}
//             placeholder="Search for Chapter..."
//             headers={["Chapter Name", "Subject Name"]}
//             optionFields={{
//               option1: "chapter_name",
//               option2: "subject_name",
//             }}
//             onDropdownClose={handleDropdownClose}
//             customwidth="20vw"
//           />
//         </div>

//         <div
//           style={{
//             border: "1px solid lightgrey",
//             marginTop: "15px",
//             width: "82vw",
//             height: "30px",
//             fontWeight: "600",
//             backgroundColor: "#D6D6D6",
//             alignContent: "center",
//             paddingLeft: "8px",
//             boxShadow: "4px 4px 4px 0px #00000040",
//           }}
//           className="singleselect-checked"
//         >
//           <p style={{ color: "#424342" }}>QUESTION </p>
//         </div>
//         <div
//           style={{
//             backgroundColor: "#FBFBFB",
//             width: "82vw",
//             boxShadow: "4px 4px 4px 0px #00000040",
//             color: "#424342",
//             padding: "10px",
//             border: "1px solid lightgrey",
//           }}
//         >
//           <div
//             style={{
//               marginTop: "10px",
//               display: "flex",
//               marginBottom: "10px",
//               alignContent: "center",
//             }}
//           >
//             <label htmlFor="">Type :</label>
//             <input
//               type="radio"
//               style={{
//                 height: "18px",
//                 width: "18px",
//                 marginLeft: "4vw",
//                 marginRight: "5px",
//               }}
//               name=""
//               id=""
//             />
//             <label htmlFor="">SINGLE SELECT </label>
//             <input
//               type="radio"
//               value="single-select"
//               checked={selectedType === "single-select"}
//               onChange={handleTypeChange}
//               style={{
//                 height: "18px",
//                 width: "18px",
//                 marginLeft: "4vw",
//                 marginRight: "5px",
//               }}
//             />
//             <label htmlFor="">MULTI SELECT </label>
//             <input
//               type="radio"
//               value="multi-select"
//               checked={selectedType === "multi-select"}
//               onChange={handleTypeChange}
//               style={{
//                 height: "18px",
//                 width: "18px",
//                 marginLeft: "4vw",
//                 marginRight: "5px",
//               }}
//             />
//             <label htmlFor="">FILL-IN BLANKS </label>
//             <input
//               type="radio"
//               value="boolean"
//               checked={selectedType === "boolean"}
//               onChange={handleTypeChange}
//               style={{
//                 height: "18px",
//                 width: "18px",
//                 marginLeft: "4vw",
//                 marginRight: "5px",
//               }}
//             />
//             <label htmlFor="">BOOLEAN </label>
//           </div>

//           <label htmlFor="">
//             Question Text <span style={{ color: "red" }}>*</span>
//           </label>

//           <div style={{ position: "relative" }}>
//             <textarea
//               style={{
//                 marginTop: "10px",
//                 minHeight: "160px",
//                 minWidth: "76vw",
//                 padding: "10px",
//                 position: "relative",
//               }}
//               id=""
//               placeholder="Type question text here"
//             ></textarea>
//             <div
//               style={{
//                 position: "absolute",
//                 top: "15px",
//                 right: "5.1vw",
//                 cursor: "pointer",
//               }}
//             >
//               <img src={ThreeDots} alt="" />
//             </div>
//           </div>

//           <div
//             style={{ marginLeft: "20px", marginTop: "10px", display: "flex" }}
//           >
//             {" "}
//             <p style={{ marginTop: "5px", marginRight: "20px" }}>A )</p>
//             <input
//               type="checkbox"
//               style={{ marginBottom: "30px" }}
//               name=""
//               id=""
//             />
//             <input
//               type="number"
//               style={{ marginLeft: "20px", width: "40px", height: "30px" }}
//             />
//             <div style={{ position: "relative" }}>
//               <textarea
//                 style={{
//                   marginLeft: "20px",
//                   width: "68vw",
//                   minHeight: "60px",
//                   padding: "10px",
//                   position: "relative",
//                 }}
//                 id=""
//               ></textarea>
//               <div
//                 style={{
//                   position: "absolute",
//                   top: "5px",
//                   right: "5px",
//                   cursor: "pointer",
//                 }}
//               >
//                 <img src={ThreeDots} alt="" />
//               </div>
//             </div>
//           </div>
//           <div
//             style={{ marginLeft: "20px", marginTop: "10px", display: "flex" }}
//           >
//             {" "}
//             <p style={{ marginTop: "5px", marginRight: "20px" }}>B )</p>
//             <input
//               type="checkbox"
//               style={{ marginBottom: "30px" }}
//               name=""
//               id=""
//             />
//             <input
//               type="number"
//               style={{ marginLeft: "20px", width: "40px", height: "30px" }}
//             />
//             <div style={{ position: "relative" }}>
//               <textarea
//                 style={{
//                   marginLeft: "20px",
//                   width: "68vw",
//                   minHeight: "60px",
//                   padding: "10px",
//                   position: "relative",
//                 }}
//                 id=""
//               ></textarea>
//               <div
//                 style={{
//                   position: "absolute",
//                   top: "5px",
//                   right: "5px",
//                   cursor: "pointer",
//                 }}
//               >
//                 <img src={ThreeDots} alt="" />
//               </div>
//             </div>
//           </div>
//           <div
//             style={{ marginLeft: "20px", marginTop: "10px", display: "flex" }}
//           >
//             {" "}
//             <p style={{ marginTop: "5px", marginRight: "20px" }}>C )</p>
//             <input
//               type="checkbox"
//               style={{ marginBottom: "30px" }}
//               name=""
//               id=""
//             />
//             <input
//               type="number"
//               style={{ marginLeft: "20px", width: "40px", height: "30px" }}
//             />
//             <div style={{ position: "relative" }}>
//               <textarea
//                 style={{
//                   marginLeft: "20px",
//                   width: "68vw",
//                   minHeight: "60px",
//                   padding: "10px",
//                   position: "relative",
//                 }}
//                 id=""
//               ></textarea>
//               <div
//                 style={{
//                   position: "absolute",
//                   top: "5px",
//                   right: "5px",
//                   cursor: "pointer",
//                 }}
//               >
//                 <img src={ThreeDots} alt="" />
//               </div>
//             </div>
//             <img
//               src={YellowPlus}
//               style={{
//                 width: "15px",
//                 height: "15px",
//                 marginLeft: "40px",
//                 marginTop: "42px",
//                 borderRadius: "10px",
//               }}
//               alt=""
//             />
//           </div>
//         </div>

//         <div
//           style={{
//             marginTop: "15px",
//             width: "82vw",
//             height: "30px",
//             fontWeight: "600",
//             backgroundColor: "#D6D6D6",
//             alignContent: "center",
//             paddingLeft: "8px",
//             boxShadow: "4px 4px 4px 0px #00000040",
//             border: "1px solid lightgrey",
//           }}
//           className="multiselect-checked"
//         >
//           <p style={{ color: "#424342" }}>QUESTION </p>
//           {/* <p>-</p> */}
//         </div>
//         <div
//           style={{
//             backgroundColor: "#FBFBFB",
//             width: "82vw",
//             boxShadow: "4px 4px 4px 0px #00000040",
//             color: "#424342",
//             padding: "10px",
//             marginBottom: "20px",
//             border: "1px solid lightgrey",
//           }}
//         >
//           <div
//             style={{
//               marginTop: "10px",
//               display: "flex",
//               marginBottom: "10px",
//               alignContent: "center",
//             }}
//           >
//             <label htmlFor="">Type :</label>

//             <input
//               type="radio"
//               style={{
//                 height: "18px",
//                 width: "18px",
//                 marginLeft: "4vw",
//                 marginRight: "5px",
//               }}
//               name=""
//               id=""
//             />
//             <label htmlFor="">SINGLE SELECT </label>
//             <input
//               type="radio"
//               style={{
//                 height: "18px",
//                 width: "18px",
//                 marginLeft: "4vw",
//                 marginRight: "5px",
//               }}
//               name=""
//               id=""
//             />
//             <label htmlFor="">MULTI SELECT </label>
//             <input
//               type="radio"
//               style={{
//                 height: "18px",
//                 width: "18px",
//                 marginLeft: "4vw",
//                 marginRight: "5px",
//               }}
//               name=""
//               id=""
//             />
//             <label htmlFor="">FILL-IN BLANKS </label>
//             <input
//               type="radio"
//               style={{
//                 height: "18px",
//                 width: "18px",
//                 marginLeft: "4vw",
//                 marginRight: "5px",
//               }}
//               name=""
//               id=""
//             />
//             <label htmlFor="">BOOLEAN </label>
//           </div>

//           <label htmlFor="">
//             Question Text <span style={{ color: "red" }}>*</span>
//           </label>

//           <div style={{ position: "relative" }}>
//             <textarea
//               style={{
//                 marginTop: "10px",
//                 minHeight: "160px",
//                 minWidth: "76vw",
//                 padding: "10px",
//                 position: "relative",
//               }}
//               id=""
//               placeholder="Type question text here"
//             ></textarea>
//             <div
//               style={{
//                 position: "absolute",
//                 top: "15px",
//                 right: "5.1vw",
//                 cursor: "pointer",
//               }}
//             >
//               <img src={ThreeDots} alt="" />
//             </div>
//           </div>

//           <div
//             style={{ marginLeft: "20px", marginTop: "10px", display: "flex" }}
//           >
//             <p style={{ marginTop: "5px", marginRight: "20px" }}>A )</p>
//             <input
//               style={{ height: "18px", width: "18px", marginTop: "5px" }}
//               type="radio"
//               name=""
//               id=""
//             />
//             <div style={{ position: "relative" }}>
//               <textarea
//                 style={{
//                   // marginTop: "10px",
//                   minHeight: "60px",
//                   minWidth: "71vw",
//                   padding: "10px",
//                   position: "relative",
//                   marginLeft: "20px",
//                 }}
//                 id=""
//               ></textarea>
//               <div
//                 style={{
//                   position: "absolute",
//                   top: "5px",
//                   right: "5px",
//                   cursor: "pointer",
//                 }}
//               >
//                 <img src={ThreeDots} alt="" />
//               </div>
//             </div>
//           </div>
//           <div
//             style={{ marginLeft: "20px", marginTop: "10px", display: "flex" }}
//           >
//             <p style={{ marginTop: "5px", marginRight: "20px" }}>B )</p>
//             <input
//               style={{ height: "18px", width: "18px", marginTop: "5px" }}
//               type="radio"
//               name=""
//               id=""
//             />

//             <div style={{ position: "relative" }}>
//               <textarea
//                 style={{
//                   // marginTop: "10px",
//                   minHeight: "60px",
//                   minWidth: "71vw",
//                   padding: "10px",
//                   position: "relative",
//                   marginLeft: "20px",
//                 }}
//                 id=""
//               ></textarea>
//               <div
//                 style={{
//                   position: "absolute",
//                   top: "5px",
//                   right: "5px",
//                   cursor: "pointer",
//                 }}
//               >
//                 <img src={ThreeDots} alt="" />
//               </div>
//             </div>
//           </div>
//           <div
//             style={{ marginLeft: "20px", marginTop: "10px", display: "flex" }}
//           >
//             <p style={{ marginTop: "5px", marginRight: "20px" }}>C )</p>
//             <input
//               style={{ height: "18px", width: "18px", marginTop: "5px" }}
//               type="radio"
//               name=""
//               id=""
//             />

//             <div style={{ position: "relative" }}>
//               <textarea
//                 style={{
//                   // marginTop: "10px",
//                   minHeight: "60px",
//                   minWidth: "71vw",
//                   padding: "10px",
//                   position: "relative",
//                   marginLeft: "20px",
//                 }}
//                 id=""
//               ></textarea>
//               <div
//                 style={{
//                   position: "absolute",
//                   top: "5px",
//                   right: "5px",
//                   cursor: "pointer",
//                 }}
//               >
//                 <img src={ThreeDots} alt="" />
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* //////////////////////// */}

//         <div
//           style={{
//             marginTop: "15px",
//             width: "82vw",
//             height: "30px",
//             fontWeight: "600",
//             backgroundColor: "#D6D6D6",
//             alignContent: "center",
//             paddingLeft: "8px",
//             boxShadow: "4px 4px 4px 0px #00000040",
//             border: "1px solid lightgrey",
//           }}
//           className="Fillintheblanks-checked"
//         >
//           <p style={{ color: "#424342" }}>QUESTION </p>
//           {/* <p>-</p> */}
//         </div>
//         <div
//           style={{
//             backgroundColor: "#FBFBFB",
//             width: "82vw",
//             boxShadow: "4px 4px 4px 0px #00000040",
//             color: "#424342",
//             padding: "10px",
//             marginBottom: "20px",
//             border: "1px solid lightgrey",
//           }}
//         >
//           <div
//             style={{
//               marginTop: "10px",
//               display: "flex",
//               marginBottom: "10px",
//               alignContent: "center",
//             }}
//           >
//             <label htmlFor="">Type :</label>

//             <input
//               type="radio"
//               style={{
//                 height: "18px",
//                 width: "18px",
//                 marginLeft: "4vw",
//                 marginRight: "5px",
//               }}
//               name=""
//               id=""
//             />
//             <label htmlFor="">SINGLE SELECT </label>
//             <input
//               type="radio"
//               style={{
//                 height: "18px",
//                 width: "18px",
//                 marginLeft: "4vw",
//                 marginRight: "5px",
//               }}
//               name=""
//               id=""
//             />
//             <label htmlFor="">MULTI SELECT </label>
//             <input
//               type="radio"
//               style={{
//                 height: "18px",
//                 width: "18px",
//                 marginLeft: "4vw",
//                 marginRight: "5px",
//               }}
//               name=""
//               id=""
//             />
//             <label htmlFor="">FILL-IN BLANKS </label>
//             <input
//               type="radio"
//               style={{
//                 height: "18px",
//                 width: "18px",
//                 marginLeft: "4vw",
//                 marginRight: "5px",
//               }}
//               name=""
//               id=""
//             />
//             <label htmlFor="">BOOLEAN </label>
//           </div>

//           <label htmlFor="">
//             Question Text <span style={{ color: "red" }}>*</span>
//           </label>

//           <div style={{ position: "relative" }}>
//             <textarea
//               style={{
//                 marginTop: "10px",
//                 minHeight: "160px",
//                 minWidth: "76vw",
//                 padding: "10px",
//                 position: "relative",
//               }}
//               id=""
//               placeholder="Type question text here"
//             ></textarea>
//             <div
//               style={{
//                 position: "absolute",
//                 top: "15px",
//                 right: "5.1vw",
//                 cursor: "pointer",
//               }}
//             >
//               <img src={ThreeDots} alt="" />
//             </div>
//           </div>

//           <div style={{ marginTop: "10px" }}>
//             <p style={{ paddingBottom: "5px" }}>
//               Correct Answer <span style={{ color: "red" }}>*</span>
//             </p>
//             <div style={{ position: "relative" }}>
//               <textarea
//                 style={{
//                   // marginTop: "10px",
//                   minHeight: "60px",
//                   minWidth: "76vw",
//                   padding: "10px",
//                   position: "relative",
//                 }}
//                 id=""
//                 placeholder="Type Answer text here"
//               ></textarea>
//               <div
//                 style={{
//                   position: "absolute",
//                   top: "5px",
//                   right: "5.1vw",
//                   cursor: "pointer",
//                 }}
//               >
//                 <img src={ThreeDots} alt="" />
//               </div>
//             </div>
//             {/* <textarea
//               type="text"
//               style={{ width: "76vw", height: "60px" }}
//               name=""
//               id=""
//             >
//               {" "}
//             </textarea> */}
//           </div>
//         </div>

//         {/* ///////////////////////// */}

//         <div
//           style={{
//             marginTop: "15px",
//             width: "82vw",
//             height: "30px",
//             fontWeight: "600",
//             backgroundColor: "#D6D6D6",
//             alignContent: "center",
//             paddingLeft: "8px",
//             boxShadow: "4px 4px 4px 0px #00000040",
//             border: "1px solid lightgrey",
//           }}
//           className="boolean-checked"
//         >
//           <div>
//             <p style={{ color: "#424342" }}>QUESTION</p>
//           </div>
//         </div>
//         <div
//           style={{
//             backgroundColor: "#FBFBFB",
//             width: "82vw",
//             boxShadow: "4px 4px 4px 0px #00000040",
//             color: "#424342",
//             padding: "10px",
//             marginBottom: "20px",
//             border: "1px solid lightgrey",
//           }}
//         >
//           <div
//             style={{
//               marginTop: "10px",
//               display: "flex",
//               marginBottom: "10px",
//               alignContent: "center",
//             }}
//           >
//             <label htmlFor="">Type :</label>

//             <input
//               type="radio"
//               style={{
//                 height: "18px",
//                 width: "18px",
//                 marginLeft: "4vw",
//                 marginRight: "5px",
//               }}
//               name=""
//               id=""
//             />
//             <label htmlFor="">SINGLE SELECT </label>
//             <input
//               type="radio"
//               style={{
//                 height: "18px",
//                 width: "18px",
//                 marginLeft: "4vw",
//                 marginRight: "5px",
//               }}
//               name=""
//               id=""
//             />
//             <label htmlFor="">MULTI SELECT </label>
//             <input
//               type="radio"
//               style={{
//                 height: "18px",
//                 width: "18px",
//                 marginLeft: "4vw",
//                 marginRight: "5px",
//               }}
//               name=""
//               id=""
//             />
//             <label htmlFor="">FILL-IN BLANKS </label>
//             <input
//               type="radio"
//               style={{
//                 height: "18px",
//                 width: "18px",
//                 marginLeft: "4vw",
//                 marginRight: "5px",
//               }}
//               name=""
//               id=""
//             />
//             <label htmlFor="">BOOLEAN </label>
//           </div>

// <div style={{ display: "flex", justifyContent: "space-between" }}>
//   <label htmlFor="">
//     Question Text <span style={{ color: "red" }}>*</span>
//   </label>
//   <div style={{ display: "flex" }}>
//     <p style={{ marginRight: "10px" }}>True - False </p>

//     <label
//       className={`switch user-status ${isClicked ? "no-border" : ""}`}
//       // style={{height:"10px"}}
//     >
//       <input type="checkbox" />
//       <span className="slider round "></span>
//     </label>
//     {/* <div className="user-status"></div> */}
//     <p style={{ marginRight: "5vw", marginLeft: "10px" }}>Yes - No</p>
//   </div>
// </div>

//           <div style={{ position: "relative" }}>
//             <textarea
//               style={{
//                 marginTop: "10px",
//                 minHeight: "160px",
//                 minWidth: "76vw",
//                 padding: "10px",
//                 position: "relative",
//               }}
//               id=""
//               placeholder="Type question text here"
//             ></textarea>
//             <div
//               style={{
//                 position: "absolute",
//                 top: "15px",
//                 right: "5.1vw",
//                 cursor: "pointer",
//               }}
//             >
//               <img src={ThreeDots} alt="" />
//             </div>
//           </div>

//           <div style={{ marginTop: "10px" }}>
//             <p style={{ paddingBottom: "5px" }}>
//               Correct Answer <span style={{ color: "red" }}>*</span>
//             </p>
//             <div style={{ padding: "10px" }}>
//               <input
//                 type="radio"
//                 style={{
//                   height: "18px",
//                   width: "18px",
//                   marginLeft: "2vw",
//                   marginRight: "5px",
//                 }}
//                 name=""
//                 id=""
//               />{" "}
//               <label htmlFor="">True</label>
//             </div>

//             <div style={{ padding: "10px" }}>
//               <input
//                 type="radio"
//                 style={{
//                   height: "18px",
//                   width: "18px",
//                   marginLeft: "2vw",
//                   marginRight: "5px",
//                 }}
//                 name=""
//                 id=""
//               />
//               <label htmlFor="">False</label>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default POP2;000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000..................................................................................................................................000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000.

// import SpeechRecognition, {
//   useSpeechRecognition,
// } from "react-speech-recognition";
// import Formulafx from "../../Assets/Images/CommanImages/Formula.png";
// import React, { useState, useCallback, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import _ from "lodash";
// import CustomSearchDropdown from "../Reports/components/FieldsComponent";
// import { API_BASE_URL } from "../../Config/Config";
// import YellowPlus from "../../Assets/Images/CommanImages/YellowPlus.png";
// import ThreeDots from "../../Assets/Images/CommanImages/ThreeDotsVertical.png";
// import RecordingStatic from "../../Assets/Images/CommanImages/RecordingStatic.png";
// import RecordingActive from "../../Assets/Images/CommanImages/RecordingActive.png";
// import ImgIcon from "../../Assets/Images/CommanImages/imgIcon.png";
// import Delete from "../../Assets/Images/CommanImages/Delete.png";
// import { useNavigate } from "react-router-dom";

// const mapDataToDropdownFormat = (dataArray, idField, nameField) => {
//   return _.uniqBy(
//     dataArray.map((item) => ({
//       id: item[idField],
//       label: item[nameField],
//     })),
//     "id"
//   );
// };

// const POP2 = () => {
//   const dispatch = useDispatch();
//   const { coursesdata } = useSelector((state) => state.course);
//   const [selectedType, setSelectedType] = useState("single-select");
//   const [resultsData, setResultsData] = useState([]);
//   const [testnamedata, setTestNameData] = useState([]);
//   const [resetKey, setResetKey] = useState(0);
//   const [selectedBatchName, setSelectedBatchName] = useState("");
//   const [testname, setTestName] = useState([]);
//   const [chapterName, setChapterName] = useState([]);
//   const [filteredSubjects, setFilteredSubjects] = useState([]);
//   const [filteredBatches, setFilteredBatches] = useState([]);
//   const [apiData, setApiData] = useState([]);
//   const [batchData, setBatchData] = useState([]);
//   const [subjectData, setSubjectData] = useState([]);
//   const [chapterData, setChapterData] = useState([]);
//   const [dppData, setDppData] = useState([]);
//   const [studentData, setStudentData] = useState([]);
//   const [selectedCourseId, setSelectedCourseId] = useState(" ");
//   const [selectedChapters, setSelectedChapters] = useState([]);
//   const [selectedDppIds, setSelectedDppIds] = useState([]);
//   const [selectedBatches, setSelectedBatches] = useState([]);
//   const [selectedSubjects, setSelectedSubjects] = useState([]);
//   const [selectedStudents, setSelectedStudents] = useState([]);
//   const [searchKey, setSearchKey] = useState("");
//   const [searchColumn, setSearchColumn] = useState("");
//   const [isClicked, setIsClicked] = useState(false);
//   // const [selectedType, setSelectedType] = useState("single-select");
//   const [text, setText] = useState("");
//   const [isListening, setIsListening] = useState(false);
//   const { transcript, resetTranscript } = useSpeechRecognition();
//   const navigate = useNavigate();
//   const [isApplied, setIsApplied] = useState(false);
//   const [hasStartedTyping, setHasStartedTyping] = useState({
//     A: false,
//     B: false,
//     C: false,
//     D: false,
//   });
//   const dropdownStyle = isApplied
//     ? { opacity: 0.5, pointerEvents: "none" }
//     : { opacity: 1, pointerEvents: "auto" };
//   const handleApplyOrReset = async () => {
//     console.log("pressed button");
//   };
//   useEffect(() => {
//     if (!SpeechRecognition.browserSupportsSpeechRecognition()) {
//       console.warn("Your browser does not support speech recognition.");
//     }
//   }, []);

//   // Update the text area whenever the transcript changes
//   useEffect(() => {
//     setText(transcript);
//   }, [transcript]);

//   const handleButtonClick = () => {
//     if (isListening) {
//       SpeechRecognition.stopListening();
//     } else {
//       SpeechRecognition.startListening({ continuous: true });
//     }
//     setIsListening(!isListening);
//   };

//   const handleTextChange = (event) => {
//     setText(event.target.value);
//   };

//   const handleTypeChange = (event) => {
//     setSelectedType(event.target.value);
//   };

//   const renderIcons = (label) => {
//     if (!hasStartedTyping[label]) return null;
//     return (
//       <>
//         <div
//           style={{
//             position: "absolute",
//             top: "5px",
//             right: "5px",
//             cursor: "pointer",
//           }}
//         >
//           <img src={ThreeDots} alt="Menu" />
//         </div>
//         <div
//           style={{
//             position: "absolute",
//             top: "5px",
//             right: "1.5vw",
//             cursor: "pointer",
//           }}
//         >
//           <img
//             style={{ height: "18px", width: "17px" }}
//             src={RecordingStatic}
//             alt="Record"
//             onClick={handleButtonClick}
//           />
//         </div>
//         <div
//           style={{
//             position: "absolute",
//             top: "5px",
//             right: "3.5vw",
//             cursor: "pointer",
//           }}
//         >
//           <img
//             style={{ height: "18px", width: "17px" }}
//             src={ImgIcon}
//             alt="Image"
//           />
//         </div>
//         <div
//           style={{
//             position: "absolute",
//             top: "5px",
//             right: "5.5vw",
//             cursor: "pointer",
//           }}
//         >
//           <img
//             style={{ height: "18px", width: "17px" }}
//             src={Formulafx}
//             alt="Formula"
//           />
//         </div>
//         <div
//           style={{
//             position: "absolute",
//             top: "5px",
//             right: "7.5vw",
//             cursor: "pointer",
//           }}
//         >
//           <img
//             style={{ height: "18px", width: "17px" }}
//             src={Delete}
//             alt="Delete"
//           />
//         </div>
//       </>
//     );
//   };

//   const renderInnerFields = () => {
//     switch (selectedType) {
//       case "single-select":
//         return (
//           <>
//             <div
//               style={{ marginLeft: "20px", marginTop: "10px", display: "flex" }}
//             >
//               <p style={{ marginTop: "5px", marginRight: "20px" }}>A )</p>
//               <input
//                 type="radio"
//                 name="single-select-options"
//                 style={{
//                   height: "18px",
//                   width: "18px",
//                   marginTop: "5px",
//                   borderColor: "#6A6A6A",
//                 }}
//               />
//               <div style={{ position: "relative" }}>
//                 <textarea
//                   style={{
//                     marginLeft: "20px",
//                     minWidth: "71vw",
//                     minHeight: "60px",
//                     padding: "10px",
//                   }}
//                   placeholder="Option A"
//                   onChange={(event) => {
//                     handleTextChange(event);
//                     setHasStartedTyping((prev) => ({ ...prev, A: true }));
//                   }}
//                 ></textarea>
//                 {renderIcons("A")}
//               </div>
//             </div>
//             <div
//               style={{ marginLeft: "20px", marginTop: "10px", display: "flex" }}
//             >
//               <p style={{ marginTop: "5px", marginRight: "20px" }}>B )</p>
//               <input
//                 type="radio"
//                 name="single-select-options"
//                 style={{
//                   height: "18px",
//                   width: "18px",
//                   marginTop: "5px",
//                   borderColor: "#6A6A6A",
//                 }}
//               />
//               <div style={{ position: "relative" }}>
//                 <textarea
//                   style={{
//                     marginLeft: "20px",
//                     minWidth: "71vw",
//                     minHeight: "60px",
//                     padding: "10px",
//                   }}
//                   placeholder="Option B"
//                   onChange={(event) => {
//                     handleTextChange(event);
//                     setHasStartedTyping((prev) => ({ ...prev, B: true }));
//                   }}
//                 ></textarea>
//                 {renderIcons("B")}
//               </div>
//             </div>
//             <div
//               style={{ marginLeft: "20px", marginTop: "10px", display: "flex" }}
//             >
//               <p style={{ marginTop: "5px", marginRight: "20px" }}>C )</p>
//               <input
//                 type="radio"
//                 name="single-select-options"
//                 style={{
//                   height: "18px",
//                   width: "18px",
//                   marginTop: "5px",
//                   borderColor: "#6A6A6A",
//                 }}
//               />
//               <div style={{ position: "relative" }}>
//                 <textarea
//                   style={{
//                     marginLeft: "20px",
//                     minWidth: "71vw",
//                     minHeight: "60px",
//                     padding: "10px",
//                   }}
//                   placeholder="Option C"
//                   onChange={(event) => {
//                     handleTextChange(event);
//                     setHasStartedTyping((prev) => ({ ...prev, C: true }));
//                   }}
//                 ></textarea>
//                 {renderIcons("C")}
//               </div>
//             </div>
//             <div
//               style={{ marginLeft: "20px", marginTop: "10px", display: "flex" }}
//             >
//               <p style={{ marginTop: "5px", marginRight: "20px" }}>D )</p>
//               <input
//                 type="radio"
//                 name="single-select-options"
//                 style={{
//                   height: "18px",
//                   width: "18px",
//                   marginTop: "5px",
//                   borderColor: "#6A6A6A",
//                 }}
//               />
//               <div style={{ position: "relative" }}>
//                 <textarea
//                   style={{
//                     marginLeft: "20px",
//                     minWidth: "71vw",
//                     minHeight: "60px",
//                     padding: "10px",
//                   }}
//                   placeholder="Option D"
//                   onChange={(event) => {
//                     handleTextChange(event);
//                     setHasStartedTyping((prev) => ({ ...prev, D: true }));
//                   }}
//                 ></textarea>
//                 {renderIcons("D")}
//               </div>
//             </div>
//           </>
//         );

//       case "multi-select":
//         return (
//           <>
//             {["A", "B", "C", "D"].map((option) => (
//               <div
//                 key={option}
//                 style={{
//                   marginLeft: "20px",
//                   marginTop: "10px",
//                   display: "flex",
//                 }}
//               >
//                 <p style={{ marginTop: "5px", marginRight: "20px" }}>
//                   {option} )
//                 </p>
//                 <input
//                   type="checkbox"
//                   name="multi-select-options"
//                   style={{ height: "18px", width: "18px", marginTop: "5px" }}
//                 />
//                 <input
//                   type="number"
//                   style={{ marginLeft: "20px", width: "40px", height: "30px" }}
//                 />
//                 <div style={{ position: "relative" }}>
//                   <textarea
//                     style={{
//                       marginLeft: "20px",
//                       minWidth: "67.9vw",
//                       minHeight: "60px",
//                       padding: "10px",
//                     }}
//                     placeholder={`Option ${option}`}
//                     onChange={() => {
//                       setHasStartedTyping((prev) => ({
//                         ...prev,
//                         [option]: true,
//                       }));
//                     }}
//                   ></textarea>
//                   {hasStartedTyping[option] && (
//                     <>
//                       <div
//                         style={{
//                           position: "absolute",
//                           top: "5px",
//                           right: "5px",
//                           cursor: "pointer",
//                         }}
//                       >
//                         <img src={ThreeDots} alt="Menu" />
//                       </div>
//                       <div
//                         style={{
//                           position: "absolute",
//                           top: "5px",
//                           right: "1.5vw",
//                           cursor: "pointer",
//                         }}
//                       >
//                         <img
//                           style={{ height: "18px", width: "17px" }}
//                           src={RecordingStatic}
//                           alt="Record"
//                           onClick={handleButtonClick}
//                         />
//                       </div>
//                       <div
//                         style={{
//                           position: "absolute",
//                           top: "5px",
//                           right: "3.5vw",
//                           cursor: "pointer",
//                         }}
//                       >
//                         <img
//                           style={{ height: "18px", width: "17px" }}
//                           src={ImgIcon}
//                           alt="Image"
//                         />
//                       </div>
//                       <div
//                         style={{
//                           position: "absolute",
//                           top: "5px",
//                           right: "5.5vw",
//                           cursor: "pointer",
//                         }}
//                       >
//                         <img
//                           style={{ height: "18px", width: "17px" }}
//                           src={Formulafx}
//                           alt="Formula"
//                         />
//                       </div>
//                       <div
//                         style={{
//                           position: "absolute",
//                           top: "5px",
//                           right: "7.5vw",
//                           cursor: "pointer",
//                         }}
//                       >
//                         <img
//                           style={{ height: "18px", width: "17px" }}
//                           src={Delete}
//                           alt="Delete"
//                         />
//                       </div>
//                     </>
//                   )}
//                 </div>
//               </div>
//             ))}
//           </>
//         );

//       case "fill-in-blanks":
//         return (
//           <>
//             <label htmlFor="" style={{ marginTop: "10px", display: "block" }}>
//               Correct Answer <span style={{ color: "red" }}>*</span>
//             </label>

//             <div style={{ position: "relative" }}>
//               <textarea
//                 style={{
//                   marginTop: "10px",
//                   minHeight: "60px",
//                   minWidth: "76vw",
//                   padding: "10px",
//                 }}
//                 placeholder="Type the correct answer here"
//               ></textarea>
//               <div
//                 style={{
//                   position: "absolute",
//                   top: "15px",
//                   right: "5.1vw",
//                   cursor: "pointer",
//                 }}
//               >
//                 <img src={ThreeDots} alt="" />
//               </div>
//               <div
//                 style={{
//                   position: "absolute",
//                   top: "15px",
//                   right: "7.1vw",
//                   cursor: "pointer",
//                 }}
//               >
//                 <img
//                   style={{ height: "18px", width: "17px" }}
//                   src={RecordingStatic}
//                   alt=""
//                   onClick={handleButtonClick}
//                 />
//               </div>

//               <div
//                 style={{
//                   position: "absolute",
//                   top: "15px",
//                   right: "9.1vw",
//                   cursor: "pointer",
//                 }}
//               >
//                 <img
//                   style={{ height: "18px", width: "17px" }}
//                   src={ImgIcon}
//                   alt=""
//                 />
//               </div>
//               <div
//                 style={{
//                   position: "absolute",
//                   top: "15px",
//                   right: "11.1vw",
//                   cursor: "pointer",
//                 }}
//               >
//                 <img
//                   style={{ height: "18px", width: "17px" }}
//                   src={Formulafx}
//                   alt=""
//                 />
//               </div>
//               <div
//                 style={{
//                   position: "absolute",
//                   top: "15px",
//                   right: "13.1vw",
//                   cursor: "pointer",
//                 }}
//               >
//                 <img
//                   style={{ height: "18px", width: "17px" }}
//                   src={Delete}
//                   alt=""
//                 />
//               </div>
//             </div>
//           </>
//         );

//       case "boolean":
//         return (
//           <>
//             <div
//               style={{
//                 marginTop: "10px",
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   flexDirection: "column",
//                   marginTop: "10px",
//                   // paddingLeft: "10px",
//                 }}
//               >
//                 <div
//                   style={{ display: "flex", justifyContent: "space-between" }}
//                 >
//                   <label>
//                     Correct Answer <span style={{ color: "red" }}>*</span>
//                   </label>
//                   <div style={{ display: "flex" }}>
//                     <p style={{ marginRight: "10px" }}>True - False </p>

//                     <label
//                       className={`switch user-status ${
//                         isClicked ? "no-border" : ""
//                       }`}
//                       // style={{height:"10px"}}
//                     >
//                       <input type="checkbox" />
//                       <span className="slider round "></span>
//                     </label>
//                     {/* <div className="user-status"></div> */}
//                     <p style={{ marginRight: "5vw", marginLeft: "10px" }}>
//                       Yes - No
//                     </p>
//                   </div>
//                 </div>
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     paddingLeft: "55px",
//                   }}
//                 >
//                   <input
//                     type="radio"
//                     name="boolean-answer"
//                     style={{
//                       height: "18px",
//                       width: "18px",
//                       marginRight: "5px",
//                     }}
//                   />
//                   <label>True</label>
//                 </div>
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     marginTop: "10px",
//                     paddingLeft: "55px",
//                   }}
//                 >
//                   <input
//                     type="radio"
//                     name="boolean-answer"
//                     style={{
//                       height: "18px",
//                       width: "18px",
//                       marginRight: "5px",
//                     }}
//                   />
//                   <label>False</label>
//                 </div>
//               </div>
//             </div>
//           </>
//         );

//       default:
//         return null;
//     }
//   };

//   return (
//     <>
//       {/* <h2 style={{ paddingLeft: "30px" }}>Add Question</h2> */}
//       <div style={{ top: "0" }}>
//         <div className="Header-up">
//           <span
//             style={{
//               color: "#2F2E40",
//               fontSize: "30px",
//               textTransform: "capitalize",
//               paddingLeft: "30px",
//             }}
//           >
//             Add Question
//           </span>
//           <div
//             className="testreportcard-header-btn-container"
//             style={{ marginRight: "30px" }}
//           >
//             <button
//               className="testreportcard-cancel-btn"
//               style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
//               // onClick={handleCancel}
//               onClick={() => navigate(-1)}
//             >
//               CANCEL
//             </button>
//             <button
//               className="testreportcard-cancel-btn"
//               style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
//               // onClick={handleCancel}
//               onClick={() => navigate(-1)}
//             >
//               SAVE
//             </button>

//             <button
//               className="testreportcard-create-btn"
//               style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
//               onClick={handleApplyOrReset}
//             >
//               {isApplied ? "SAVE +" : "SAVE +"}
//             </button>
//           </div>
//         </div>
//       </div>
//       <div style={{ paddingLeft: "30px", paddingTop: "15px" }}>
//         <div
//           style={{
//             width: "82vw",
//             height: "30px",
//             fontWeight: "600",
//             backgroundColor: "#D6D6D6",
//             alignContent: "center",
//             paddingLeft: "8px",
//             boxShadow: "4px 4px 4px 0px #00000040",
//             border: "1px solid lightgrey",
//           }}
//         >
//           <p style={{ color: "#424342" }}>QUESTION TAGGING</p>
//         </div>
//         <div
//           style={{
//             backgroundColor: "#FBFBFB",
//             width: "82vw",
//             boxShadow: "4px 4px 4px 0px #00000040",
//             color: "#424342",
//             padding: "10px",
//             border: "1px solid lightgrey",
//           }}
//         >
//           <div className="row-cs-uni" style={{ color: "#424342 " }}>
//             <div className="col-cs">
//               {" "}
//               <CustomSearchDropdown
//                 label="Set Name "
//                 optionsData={chapterData}
//                 selected={selectedChapters}
//                 setSelected={setSelectedChapters}
//                 headers={["Chapter Name", "Subject Name"]}
//                 optionFields={{
//                   option1: "chapter_name",
//                   option2: "subject_name",
//                 }}
//                 width="100%"
//               />
//               <CustomSearchDropdown
//                 label="Class"
//                 optionsData={chapterData}
//                 selected={selectedChapters}
//                 setSelected={setSelectedChapters}
//                 headers={["Chapter Name", "Subject Name"]}
//                 optionFields={{
//                   option1: "chapter_name",
//                   option2: "subject_name",
//                 }}
//                 width="100%"
//               />
//               <CustomSearchDropdown
//                 label="Difficulty Level"
//                 optionsData={chapterData}
//                 selected={selectedChapters}
//                 setSelected={setSelectedChapters}
//                 headers={["Chapter Name", "Subject Name"]}
//                 optionFields={{
//                   option1: "chapter_name",
//                   option2: "subject_name",
//                 }}
//                 width="100%"
//               />
//             </div>
//             <div className="col-cs">
//               {" "}
//               <CustomSearchDropdown
//                 label="Course"
//                 optionsData={chapterData}
//                 selected={selectedChapters}
//                 setSelected={setSelectedChapters}
//                 headers={["Chapter Name", "Subject Name"]}
//                 optionFields={{
//                   option1: "chapter_name",
//                   option2: "subject_name",
//                 }}
//                 width="100%"
//               />
//               <CustomSearchDropdown
//                 label="Chapter"
//                 optionsData={chapterData}
//                 selected={selectedChapters}
//                 setSelected={setSelectedChapters}
//                 headers={["Chapter Name", "Subject Name"]}
//                 optionFields={{
//                   option1: "chapter_name",
//                   option2: "subject_name",
//                 }}
//                 width="100%"
//               />
//               <div
//                 style={{
//                   marginTop: "40px",
//                   display: "flex",
//                   alignItems: "center",
//                 }}
//               >
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     marginRight: "10px",
//                   }}
//                 >
//                   <input
//                     style={{ height: "18px", width: "18px" }}
//                     type="checkbox"
//                     name=""
//                     id=""
//                   />
//                   <label style={{ marginLeft: "10px" }}>Important</label>
//                 </div>
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     marginRight: "10px",
//                   }}
//                 >
//                   <input
//                     style={{ height: "18px", width: "18px" }}
//                     type="checkbox"
//                     name=""
//                     id=""
//                   />
//                   <label style={{ marginLeft: "10px" }} htmlFor="">
//                     NCERT
//                   </label>
//                 </div>
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     marginRight: "10px",
//                   }}
//                 >
//                   <input
//                     style={{ height: "18px", width: "18px" }}
//                     type="checkbox"
//                     name=""
//                     id=""
//                   />
//                   <label style={{ marginLeft: "10px" }} htmlFor="">
//                     PYQ
//                   </label>
//                 </div>
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     marginRight: "10px",
//                   }}
//                 >
//                   <input
//                     style={{ height: "18px", width: "18px" }}
//                     type="checkbox"
//                     name=""
//                     id=""
//                   />
//                   <label style={{ marginLeft: "10px" }} htmlFor="">
//                     CBSE
//                   </label>
//                 </div>
//               </div>
//             </div>
//             <div className="col-cs">
//               {" "}
//               <CustomSearchDropdown
//                 label="Subject"
//                 optionsData={chapterData}
//                 selected={selectedChapters}
//                 setSelected={setSelectedChapters}
//                 headers={["Chapter Name", "Subject Name"]}
//                 optionFields={{
//                   option1: "chapter_name",
//                   option2: "subject_name",
//                 }}
//                 width="100%"
//               />
//               <CustomSearchDropdown
//                 label="Topic"
//                 optionsData={chapterData}
//                 selected={selectedChapters}
//                 setSelected={setSelectedChapters}
//                 headers={["Chapter Name", "Subject Name"]}
//                 optionFields={{
//                   option1: "chapter_name",
//                   option2: "subject_name",
//                 }}
//                 width="100%"
//               />
//             </div>
//           </div>
//         </div>

//         <div
//           style={{
//             marginTop: "15px",
//             width: "82vw",
//             height: "30px",
//             fontWeight: "600",
//             backgroundColor: "#D6D6D6",
//             alignContent: "center",
//             paddingLeft: "8px",
//             boxShadow: "4px 4px 4px 0px #00000040",
//             border: "1px solid lightgrey",
//           }}
//         >
//           {" "}
//           <label style={{ color: "#424342" }} htmlFor="">
//             Question
//           </label>
//         </div>
//         <div
//           style={{
//             // marginTop: "15px",
//             backgroundColor: "#FBFBFB",
//             width: "82vw",
//             boxShadow: "4px 4px 4px 0px #00000040",
//             color: "#424342",
//             padding: "10px",
//             marginBottom: "20px",
//             border: "1px solid lightgrey",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               marginTop: "15px",
//               color: "#2F2E40",
//             }}
//           >
//             <label>Type:</label>
//             <input
//               type="radio"
//               value="single-select"
//               checked={selectedType === "single-select"}
//               onChange={handleTypeChange}
//               style={{ marginLeft: "20px", borderColor: "#6A6A6A" }}
//             />
//             <label style={{ marginLeft: "7px" }}>Single Select</label>
//             <input
//               type="radio"
//               value="multi-select"
//               checked={selectedType === "multi-select"}
//               onChange={handleTypeChange}
//               style={{ marginLeft: "20px", borderColor: "#6A6A6A" }}
//             />
//             <label style={{ marginLeft: "7px" }}>Multi Select</label>
//             <input
//               type="radio"
//               value="fill-in-blanks"
//               checked={selectedType === "fill-in-blanks"}
//               onChange={handleTypeChange}
//               style={{ marginLeft: "20px", borderColor: "#6A6A6A" }}
//             />
//             <label style={{ marginLeft: "7px" }}>Fill-In Blanks</label>
//             <input
//               type="radio"
//               value="boolean"
//               checked={selectedType === "boolean"}
//               onChange={handleTypeChange}
//               style={{ marginLeft: "20px", borderColor: "#6A6A6A" }}
//             />
//             <label style={{ marginLeft: "7px" }}>Boolean</label>
//           </div>

//           <p style={{ marginTop: "20px ", marginBottom: "10px" }}>
//             Question Text <span style={{ color: "red" }}>*</span>
//           </p>
//           <div style={{ position: "relative" }}>
//             <textarea
//               value={text}
//               onChange={handleTextChange}
//               style={{
//                 marginTop: "10px",
//                 minHeight: "160px",
//                 minWidth: "76vw",
//                 padding: "10px",
//                 paddingTop: "30px",
//                 position: "relative",
//                 color: "#424242",
//                 fontSize: "16px",
//               }}
//               placeholder="Type question text here"
//             ></textarea>
//             <div
//               style={{
//                 position: "absolute",
//                 top: "15px",
//                 right: "5.1vw",
//                 cursor: "pointer",
//               }}
//             >
//               <img src={ThreeDots} alt="" />
//             </div>
//             <div
//               style={{
//                 position: "absolute",
//                 top: "15px",
//                 right: "6.3vw",
//                 cursor: "pointer",
//               }}
//             >
//               <img
//                 style={{ height: "18px", width: "17px" }}
//                 src={RecordingStatic}
//                 alt=""
//                 onClick={handleButtonClick}
//               />
//             </div>
//             <div
//               style={{
//                 position: "absolute",
//                 top: "-60px",
//                 right: "6.3vw",
//                 cursor: "pointer",
//               }}
//             >
//               <img
//                 className={isListening ? "blinking" : ""}
//                 style={{ height: "18px", width: "17px" }}
//                 src={RecordingActive}
//                 alt=""
//               />
//             </div>

//             <div
//               style={{
//                 position: "absolute",
//                 top: "15px",
//                 right: "8.3vw",
//                 cursor: "pointer",
//               }}
//             >
//               <img
//                 style={{ height: "18px", width: "17px" }}
//                 src={ImgIcon}
//                 alt=""
//               />
//             </div>
//             <div
//               style={{
//                 position: "absolute",
//                 top: "15px",
//                 right: "10.3vw",
//                 cursor: "pointer",
//               }}
//             >
//               <img
//                 style={{ height: "18px", width: "17px" }}
//                 src={Formulafx}
//                 alt=""
//               />
//             </div>
//             {/* <div
//               style={{
//                 position: "absolute",
//                 top: "15px",
//                 right: "11.1vw",
//                 cursor: "pointer",
//               }}
//             >
//               <img
//                 style={{ height: "18px", width: "17px" }}
//                 src={Delete}
//                 alt=""
//               />
//             </div> */}
//           </div>
//           {renderInnerFields()}
//         </div>
//       </div>
//     </>
//   );
// };

// export default POP2;

// import SpeechRecognition, {
//   useSpeechRecognition,
// } from "react-speech-recognition";
// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import CustomSearchDropdown from "../Reports/components/FieldsComponent";
// import Formulafx from "../../Assets/Images/CommanImages/Formula.png";
// import ThreeDots from "../../Assets/Images/CommanImages/ThreeDotsVertical.png";
// import RecordingStatic from "../../Assets/Images/CommanImages/RecordingStatic.png";
// import ImgIcon from "../../Assets/Images/CommanImages/imgIcon.png";
// import Delete from "../../Assets/Images/CommanImages/Delete.png";
// import { useNavigate } from "react-router-dom";

// const TextareaWithIcons = ({
//   label,
//   placeholder,
//   onTextChange,
//   isListening,
//   onRecordClick,
//   onIconClick,
//   hasStartedTyping,
// }) => {
//   return (
//     <div style={{ position: "relative", marginTop: "10px" }}>
//       <p style={{ marginBottom: "5px" }}>{label}</p>
//       <textarea
//         style={{
//           minWidth: "71vw",
//           minHeight: "60px",
//           padding: "10px",
//         }}
//         placeholder={placeholder}
//         onChange={onTextChange}
//       ></textarea>
//       {hasStartedTyping && (
//         <>
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "5px",
//               cursor: "pointer",
//             }}
//           >
//             <img src={ThreeDots} alt="Menu" onClick={onIconClick} />
//           </div>
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "1.5vw",
//               cursor: "pointer",
//             }}
//           >
//             <img
//               style={{ height: "18px", width: "17px" }}
//               src={RecordingStatic}
//               alt="Record"
//               onClick={onRecordClick}
//             />
//           </div>
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "3.5vw",
//               cursor: "pointer",
//             }}
//           >
//             <img
//               style={{ height: "18px", width: "17px" }}
//               src={ImgIcon}
//               alt="Image"
//             />
//           </div>
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "5.5vw",
//               cursor: "pointer",
//             }}
//           >
//             <img
//               style={{ height: "18px", width: "17px" }}
//               src={Formulafx}
//               alt="Formula"
//             />
//           </div>
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "7.5vw",
//               cursor: "pointer",
//             }}
//           >
//             <img
//               style={{ height: "18px", width: "17px" }}
//               src={Delete}
//               alt="Delete"
//             />
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// const DropdownWithLabel = ({ label, optionsData, selected, setSelected }) => (
//   <CustomSearchDropdown
//     label={label}
//     optionsData={optionsData}
//     selected={selected}
//     setSelected={setSelected}
//     headers={["Chapter Name", "Subject Name"]}
//     optionFields={{
//       option1: "chapter_name",
//       option2: "subject_name",
//     }}
//     width="100%"
//   />
// );

// const POP2 = () => {
//   const dispatch = useDispatch();
//   const { coursesdata } = useSelector((state) => state.course);
//   const navigate = useNavigate();
//   const [selectedType, setSelectedType] = useState("single-select");
//   const [chapterData, setChapterData] = useState([]);
//   const [selectedChapters, setSelectedChapters] = useState([]);
//   const [isListening, setIsListening] = useState(false);
//   const { transcript } = useSpeechRecognition();
//   const [text, setText] = useState(transcript);
//   const [hasStartedTyping, setHasStartedTyping] = useState({
//     A: false,
//     B: false,
//     C: false,
//     D: false,
//   });

//   const handleTypeChange = (event) => setSelectedType(event.target.value);

//   const handleButtonClick = () => {
//     if (isListening) {
//       SpeechRecognition.stopListening();
//     } else {
//       SpeechRecognition.startListening({ continuous: true });
//     }
//     setIsListening(!isListening);
//   };

//   const handleTextChange = (event) => setText(event.target.value);

//   useEffect(() => {
//     setText(transcript);
//   }, [transcript]);

//   const renderInnerFields = () => {
//     switch (selectedType) {
//       case "single-select":
//         return ["A", "B", "C", "D"].map((option) => (
//           <TextareaWithIcons
//             key={option}
//             label={`${option} )`}
//             placeholder={`Option ${option}`}
//             onTextChange={(event) => {
//               handleTextChange(event);
//               setHasStartedTyping((prev) => ({ ...prev, [option]: true }));
//             }}
//             isListening={isListening}
//             onRecordClick={handleButtonClick}
//             hasStartedTyping={hasStartedTyping[option]}
//           />
//         ));
//       case "multi-select":
//         return ["A", "B", "C", "D"].map((option) => (
//           <TextareaWithIcons
//             key={option}
//             label={`${option} )`}
//             placeholder={`Option ${option}`}
//             onTextChange={() =>
//               setHasStartedTyping((prev) => ({ ...prev, [option]: true }))
//             }
//             isListening={isListening}
//             onRecordClick={handleButtonClick}
//             hasStartedTyping={hasStartedTyping[option]}
//           />
//         ));
//       // Include other cases as necessary
//       default:
//         return null;
//     }
//   };

//   return (
//     <div>
//       <div className="Header-up">
//         <span className="header-title">Add Question</span>
//         <div className="header-buttons">
//           <button onClick={() => navigate(-1)}>CANCEL</button>
//           <button onClick={() => navigate(-1)}>SAVE</button>
//           <button onClick={() => {}}>SAVE +</button>
//         </div>
//       </div>
//       <div className="content">
//         <div className="dropdown-section">
//           <DropdownWithLabel
//             label="Set Name"
//             optionsData={chapterData}
//             selected={selectedChapters}
//             setSelected={setSelectedChapters}
//           />
//           <DropdownWithLabel
//             label="Class"
//             optionsData={chapterData}
//             selected={selectedChapters}
//             setSelected={setSelectedChapters}
//           />
//           <DropdownWithLabel
//             label="Difficulty Level"
//             optionsData={chapterData}
//             selected={selectedChapters}
//             setSelected={setSelectedChapters}
//           />
//         </div>
//         <div className="question-section">
//           <label>Type:</label>
//           <input
//             type="radio"
//             value="single-select"
//             checked={selectedType === "single-select"}
//             onChange={handleTypeChange}
//           />
//           Single Select
//           <input
//             type="radio"
//             value="multi-select"
//             checked={selectedType === "multi-select"}
//             onChange={handleTypeChange}
//           />
//           Multi Select
//           {/* Add other options as necessary */}
//         </div>
//         <TextareaWithIcons
//           label="Question Text"
//           placeholder="Type question text here"
//           onTextChange={handleTextChange}
//           isListening={isListening}
//           onRecordClick={handleButtonClick}
//           hasStartedTyping={true}
//         />
//         {renderInnerFields()}
//       </div>
//     </div>
//   );
// };

// export default POP2;

// import ThreeDots from "../../Assets/Images/CommanImages/ThreeDotsVertical.png";
// import RecordingStatic from "../../Assets/Images/CommanImages/RecordingStatic.png";
// import RecordingActive from "../../Assets/Images/CommanImages/RecordingActive.png";
// import Formulafx from "../../Assets/Images/CommanImages/Formula.png";

// import SpeechRecognition, {
//   useSpeechRecognition,
// } from "react-speech-recognition";
// import { useDispatch, useSelector } from "react-redux";
// import CustomSearchDropdown from "../Reports/components/FieldsComponent";
// import ImgIcon from "../../Assets/Images/CommanImages/imgIcon.png";
// import Delete from "../../Assets/Images/CommanImages/Delete.png";
// import { useNavigate } from "react-router-dom";
// import "mathlive";
// import React, { useState, useEffect } from "react";

// import DropdownWithLabel from "./DropdownWithLabel";
// import Modal from "./Modal";
// import MathLive from "./FileComp7";
// import TextboxWithImage from "./FileComp6";
// import TextareaWithIcons from "./TextareaWithIcons";
// const POP2 = () => {
//   const [selectedType, setSelectedType] = useState("single-select"); // Option type
//   const [isClicked, setIsClicked] = useState(false); // Toggle rendering
//   const [editorHtml, setEditorHtml] = useState(""); // State for FormulaQuill content
//   const [latex, setLatex] = useState(""); // State for MathLive content
//   const [showModal, setShowModal] = useState(false);

//   const handleTextChange = (event) => setText(event.target.value);

//   const dispatch = useDispatch();
//   const { coursesdata } = useSelector((state) => state.course);
//   const navigate = useNavigate();
//   const [chapterData, setChapterData] = useState([]);
//   const [selectedChapters, setSelectedChapters] = useState([]);
//   const { transcript } = useSpeechRecognition();
//   const [text, setText] = useState(transcript);
//   const [hasStartedTyping, setHasStartedTyping] = useState({
//     A: false,
//     B: false,
//     C: false,
//     D: false,
//   });
//   const [focusedField, setFocusedField] = useState(null); // Currently focused field
//   const [fieldContents, setFieldContents] = useState({
//     A: "",
//     B: "",
//     C: "",
//     D: "",
//   }); // Content for all fields
//   const [renderHtml, setRenderHtml] = useState(""); // HTML content for the render div
//   const handleFieldFocus = (field) => {
//     setFocusedField(field);
//     setRenderHtml(convertLatexToHtml(fieldContents[field] || ""));
//   };

//   // Function to handle content change
//   const handleFieldChange = (field, content) => {
//     setFieldContents((prev) => {
//       const updated = { ...prev, [field]: content };
//       if (focusedField === field) {
//         setRenderHtml(convertLatexToHtml(content));
//       }
//       return updated;
//     });
//   };

//   // Dummy LaTeX to HTML conversion
//   const convertLatexToHtml = (latex) => {
//     // Replace with a proper LaTeX-to-HTML library if needed
//     return latex.replace(/\\textbf\{(.*?)\}/g, "<b>$1</b>");
//   };
//   // const handleFieldChange = (field, content) => {
//   //   setFieldContents((prev) => ({ ...prev, [field]: content })); // Update field content
//   // };
//   // const renderInnerFields = () => {
//   //   switch (selectedType) {
//   //     case "single-select":
//   //       return ["A", "B", "C", "D"].map((option) => (
//   //         <TextareaWithIcons
//   //           key={option}
//   //           label={`${option} )`}
//   //           placeholder={`Option ${option}`}
//   //           onChange={(event) => {
//   //             handleTextChange(event);
//   //             setHasStartedTyping((prev) => ({ ...prev, [option]: true }));
//   //           }}
//   //           hasStartedTyping={hasStartedTyping[option]}
//   //           inputType="radio"
//   //         />
//   //       ));
//   //     case "multi-select":
//   //       return ["A", "B", "C", "D"].map((option) => (
//   //         <TextareaWithIcons
//   //           key={option}
//   //           label={`${option} )`}
//   //           placeholder={`Option ${option}`}
//   //           onChange={() =>
//   //             setHasStartedTyping((prev) => ({ ...prev, [option]: true }))
//   //           }
//   //           hasStartedTyping={hasStartedTyping[option]}
//   //           inputType="checkbox"
//   //           additionalInput
//   //         />
//   //       ));
//   //     case "fill-in-blanks":
//   //       return (
//   //         <div style={{ marginTop: "10px" }}>
//   //           <label htmlFor="" style={{ display: "block" }}>
//   //             Correct Answer <span style={{ color: "red" }}>*</span>
//   //           </label>
//   //           <div style={{ position: "relative" }}>
//   //             <textarea
//   //               style={{
//   //                 marginTop: "10px",
//   //                 minHeight: "60px",
//   //                 minWidth: "76vw",
//   //                 padding: "10px",
//   //               }}
//   //               placeholder="Type the correct answer here"
//   //               onChange={handleTextChange}
//   //             ></textarea>
//   //             <div
//   //               style={{
//   //                 position: "absolute",
//   //                 top: "5px",
//   //                 right: "5px",
//   //                 cursor: "pointer",
//   //               }}
//   //             >
//   //               <img src={ThreeDots} alt="Menu" />
//   //             </div>
//   //             <div
//   //               style={{
//   //                 position: "absolute",
//   //                 top: "5px",
//   //                 right: "3vw",
//   //                 cursor: "pointer",
//   //               }}
//   //             >
//   //               <img
//   //                 style={{ height: "18px", width: "17px" }}
//   //                 src={RecordingStatic}
//   //                 alt="Record"
//   //               />
//   //             </div>
//   //             <div
//   //               style={{
//   //                 position: "absolute",
//   //                 top: "5px",
//   //                 right: "6vw",
//   //                 cursor: "pointer",
//   //               }}
//   //             >
//   //               <img
//   //                 style={{ height: "18px", width: "17px" }}
//   //                 src={ImgIcon}
//   //                 alt="Image"
//   //               />
//   //             </div>
//   //             <div
//   //               style={{
//   //                 position: "absolute",
//   //                 top: "5px",
//   //                 right: "9vw",
//   //                 cursor: "pointer",
//   //               }}
//   //             >
//   //               <img
//   //                 style={{ height: "18px", width: "17px" }}
//   //                 src={Formulafx}
//   //                 alt="Formula"
//   //               />
//   //             </div>
//   //             <div
//   //               style={{
//   //                 position: "absolute",
//   //                 top: "5px",
//   //                 right: "12vw",
//   //                 cursor: "pointer",
//   //               }}
//   //             >
//   //               <img
//   //                 style={{ height: "18px", width: "17px" }}
//   //                 src={Delete}
//   //                 alt="Delete"
//   //               />
//   //             </div>
//   //           </div>
//   //         </div>
//   //       );
//   //     case "boolean":
//   //       return (
//   //         <div style={{ marginTop: "10px" }}>
//   //           <label>
//   //             Correct Answer <span style={{ color: "red" }}>*</span>
//   //           </label>
//   //           <div
//   //             style={{
//   //               display: "flex",
//   //               alignItems: "center",
//   //               marginTop: "10px",
//   //             }}
//   //           >
//   //             <input
//   //               type="radio"
//   //               name="boolean-answer"
//   //               style={{
//   //                 height: "18px",
//   //                 width: "18px",
//   //                 marginRight: "5px",
//   //               }}
//   //             />
//   //             <label>True</label>
//   //           </div>
//   //           <div
//   //             style={{
//   //               display: "flex",
//   //               alignItems: "center",
//   //               marginTop: "10px",
//   //             }}
//   //           >
//   //             <input
//   //               type="radio"
//   //               name="boolean-answer"
//   //               style={{
//   //                 height: "18px",
//   //                 width: "18px",
//   //                 marginRight: "5px",
//   //               }}
//   //             />
//   //             <label>False</label>
//   //           </div>
//   //         </div>
//   //       );
//   //     default:
//   //       return null;
//   //   }
//   // };

//   const renderInnerFields = () => {
//     return ["A", "B", "C", "D"].map((option) => (
//       <TextareaWithIcons
//         key={option}
//         label={`${option} )`}
//         placeholder={`Option ${option}`}
//         onChange={(e) => handleFieldChange(option, e.target.value)}
//         onFocus={() => handleFieldFocus(option)}
//         hasStartedTyping={Boolean(fieldContents[option])}
//       />
//     ));
//   };

//   return (
//     <>
//       <div className="Header-up">
//         <span
//           style={{
//             color: "#2F2E40",
//             fontSize: "30px",
//             textTransform: "capitalize",
//             paddingLeft: "30px",
//           }}
//         >
//           Add Question
//         </span>
//         <div
//           className="testreportcard-header-btn-container"
//           style={{ marginRight: "30px" }}
//         >
//           <button
//             className="testreportcard-cancel-btn"
//             style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
//             onClick={() => navigate(-1)}
//           >
//             CANCEL
//           </button>
//           <button
//             className="testreportcard-cancel-btn"
//             style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
//             onClick={() => navigate(-1)}
//           >
//             SAVE
//           </button>
//           <button
//             className="testreportcard-create-btn"
//             style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
//             onClick={() => {}}
//           >
//             SAVE +
//           </button>
//         </div>
//       </div>
//       <div style={{ paddingLeft: "30px", paddingTop: "15px" }}>
//         <div
//           style={{
//             width: "82vw",
//             height: "30px",
//             fontWeight: "600",
//             backgroundColor: "#D6D6D6",
//             alignContent: "center",
//             paddingLeft: "8px",
//             boxShadow: "4px 4px 4px 0px #00000040",
//             border: "1px solid lightgrey",
//           }}
//         >
//           <p style={{ color: "#424342" }}>QUESTION TAGGING</p>
//         </div>
//         <div
//           style={{
//             backgroundColor: "#FBFBFB",
//             height: "auto",
//             width: "82vw",
//             boxShadow: "4px 4px 4px 0px #00000040",
//             color: "#424342",
//             padding: "10px",
//             border: "1px solid lightgrey",
//           }}
//         >
//           <div className="row-cs-uni" style={{ color: "#424342 " }}>
//             <div className="col-cs">
//               <DropdownWithLabel
//                 label="Set Name"
//                 optionsData={chapterData}
//                 selected={selectedChapters}
//                 setSelected={setSelectedChapters}
//               />
//               <DropdownWithLabel
//                 label="Class"
//                 optionsData={chapterData}
//                 selected={selectedChapters}
//                 setSelected={setSelectedChapters}
//               />
//               <DropdownWithLabel
//                 label="Difficulty Level"
//                 optionsData={chapterData}
//                 selected={selectedChapters}
//                 setSelected={setSelectedChapters}
//               />
//             </div>
//             <div className="col-cs">
//               <DropdownWithLabel
//                 label="Course"
//                 optionsData={chapterData}
//                 selected={selectedChapters}
//                 setSelected={setSelectedChapters}
//               />
//               <DropdownWithLabel
//                 label="Chapter"
//                 optionsData={chapterData}
//                 selected={selectedChapters}
//                 setSelected={setSelectedChapters}
//               />
//               <div
//                 style={{
//                   marginTop: "40px",
//                   display: "flex",
//                   alignItems: "center",
//                 }}
//               >
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     marginRight: "10px",
//                   }}
//                 >
//                   <input
//                     style={{ height: "18px", width: "18px" }}
//                     type="checkbox"
//                     name=""
//                     id=""
//                   />
//                   <label style={{ marginLeft: "10px" }}>Important</label>
//                 </div>
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     marginRight: "10px",
//                   }}
//                 >
//                   <input
//                     style={{ height: "18px", width: "18px" }}
//                     type="checkbox"
//                     name=""
//                     id=""
//                   />
//                   <label style={{ marginLeft: "10px" }} htmlFor="">
//                     NCERT
//                   </label>
//                 </div>
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     marginRight: "10px",
//                   }}
//                 >
//                   <input
//                     style={{ height: "18px", width: "18px" }}
//                     type="checkbox"
//                     name=""
//                     id=""
//                   />
//                   <label style={{ marginLeft: "10px" }} htmlFor="">
//                     PYQ
//                   </label>
//                 </div>
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     marginRight: "10px",
//                   }}
//                 >
//                   <input
//                     style={{ height: "18px", width: "18px" }}
//                     type="checkbox"
//                     name=""
//                     id=""
//                   />
//                   <label style={{ marginLeft: "10px" }} htmlFor="">
//                     CBSE
//                   </label>
//                 </div>
//               </div>
//             </div>
//             <div className="col-cs">
//               <DropdownWithLabel
//                 label="Subject"
//                 optionsData={chapterData}
//                 selected={selectedChapters}
//                 setSelected={setSelectedChapters}
//               />
//               <DropdownWithLabel
//                 label="Topic"
//                 optionsData={chapterData}
//                 selected={selectedChapters}
//                 setSelected={setSelectedChapters}
//               />
//             </div>
//           </div>
//         </div>

//         <div
//           style={{
//             marginTop: "15px",
//             width: "82vw",
//             height: "30px",
//             fontWeight: "600",
//             backgroundColor: "#D6D6D6",
//             alignContent: "center",
//             paddingLeft: "8px",
//             boxShadow: "4px 4px 4px 0px #00000040",
//             border: "1px solid lightgrey",
//           }}
//         >
//           <label style={{ color: "#424342" }} htmlFor="">
//             Question
//           </label>
//         </div>
//         <div
//           style={{
//             backgroundColor: "#FBFBFB",
//             width: "82vw",
//             height: "auto",
//             boxShadow: "4px 4px 4px 0px #00000040",
//             color: "#424342",
//             padding: "10px",
//             marginBottom: "20px",
//             border: "1px solid lightgrey",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               marginTop: "15px",
//               color: "#2F2E40",
//             }}
//           >
//             <label>Type:</label>
//             <select
//               onChange={(e) => setSelectedType(e.target.value)}
//               value={selectedType}
//             >
//               <option value="single-select">Single Select</option>
//               <option value="multi-select">Multi Select</option>
//               <option value="fill-in-blanks">Fill in Blanks</option>
//               <option value="boolean">Boolean</option>
//             </select>
//           </div>

//           <p style={{ marginTop: "20px", marginBottom: "10px" }}>
//             Question Text <span style={{ color: "red" }}>*</span>
//           </p>
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: "15px",
//             }}
//           >
//                <TextboxWithImage htmlContent={renderHtml} />
//             {renderInnerFields()}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default POP2;

// import SpeechRecognition, {
//   useSpeechRecognition,
// } from "react-speech-recognition";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import "mathlive";
// import React, { useState, useEffect } from "react";
// import DropdownWithLabel from "./DropdownWithLabel";
// import TextboxWithImage from "./FileComp6";
// const POP2 = () => {
//   const [selectedType, setSelectedType] = React.useState("single-select");
//   const [isClicked, setIsClicked] = useState(false); // Toggle rendering
//   const [editorHtml, setEditorHtml] = useState(""); // State for FormulaQuill content
//   const [latex, setLatex] = useState(""); // State for MathLive content
//   const [showModal, setShowModal] = useState(false);

//   const handleTextChange = (event) => setText(event.target.value);
//   const [questionCounter, setQuestionCounter] = useState(0);

//   // const incrementCounter = () => {
//   //   for (let i = questionCounter; ; i++) {
//   //     setQuestionCounter(i + 1); // Increment and update the counter
//   //     break; // Exit the loop immediately after incrementing
//   //   }
//   // };
//   const incrementCounter = () => {
//     setQuestionCounter((prevCounter) => prevCounter + 1);
//   };

//   const dispatch = useDispatch();
//   const { coursesdata } = useSelector((state) => state.course);
//   const navigate = useNavigate();
//   const [chapterData, setChapterData] = useState([]);
//   const [selectedChapters, setSelectedChapters] = useState([]);
//   const { transcript } = useSpeechRecognition();
//   const [text, setText] = useState(transcript);
//   const [hasStartedTyping, setHasStartedTyping] = useState({
//     A: false,
//     B: false,
//     C: false,
//     D: false,
//   });
//   const [focusedField, setFocusedField] = useState(null); // Currently focused field
//   const [fieldContents, setFieldContents] = useState({
//     A: "",
//     B: "",
//     C: "",
//     D: "",
//   }); // Content for all fields
//   const [renderHtml, setRenderHtml] = useState(""); // HTML content for the render div
//   const handleFieldFocus = (field) => {
//     setFocusedField(field);
//     setRenderHtml(convertLatexToHtml(fieldContents[field] || ""));
//   };

//   // Function to handle content change
//   const handleFieldChange = (field, content) => {
//     setFieldContents((prev) => {
//       const updated = { ...prev, [field]: content };
//       if (focusedField === field) {
//         setRenderHtml(convertLatexToHtml(content));
//       }
//       return updated;
//     });
//   };

//   // Dummy LaTeX to HTML conversion
//   const convertLatexToHtml = (latex) => {
//     // Replace with a proper LaTeX-to-HTML library if needed
//     return latex.replace(/\\textbf\{(.*?)\}/g, "<b>$1</b>");
//   };

//   return (
//     <>
//       <div className="Header-up">
//         <span
//           style={{
//             color: "#2F2E40",
//             fontSize: "30px",
//             textTransform: "capitalize",
//             paddingLeft: "30px",
//           }}
//         >
//           Add Question
//         </span>
//         <div
//           className="testreportcard-header-btn-container"
//           style={{ marginRight: "30px" }}
//         >
//           <button
//             className="testreportcard-cancel-btn"
//             style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
//             onClick={() => navigate(-1)}
//           >
//             CANCEL
//           </button>
//           <button
//             className="testreportcard-cancel-btn"
//             style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
//             onClick={() => navigate(-1)}
//           >
//             SAVE
//           </button>
//           <button
//             className="testreportcard-create-btn"
//             style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
//             onClick={incrementCounter} // Increment the counter
//           >
//             SAVE +
//           </button>
//         </div>
//       </div>
//       <div style={{ paddingLeft: "30px", paddingTop: "15px" }}>
//         <div
//           style={{
//             width: "82vw",
//             height: "30px",
//             fontWeight: "600",
//             backgroundColor: "#D6D6D6",
//             alignContent: "center",
//             paddingLeft: "8px",
//             boxShadow: "4px 4px 4px 0px #00000040",
//             border: "1px solid lightgrey",
//           }}
//         >
//           <p style={{ color: "#424342" }}>QUESTION TAGGING</p>
//         </div>
//         <div
//           style={{
//             backgroundColor: "#FBFBFB",
//             height: "auto",
//             width: "82vw",
//             boxShadow: "4px 4px 4px 0px #00000040",
//             color: "#424342",
//             padding: "10px",
//             border: "1px solid lightgrey",
//           }}
//         >
//           <div className="row-cs-uni" style={{ color: "#424342 " }}>
//             <div className="col-cs">
//               <DropdownWithLabel
//                 label="Set Name"
//                 optionsData={chapterData}
//                 selected={selectedChapters}
//                 setSelected={setSelectedChapters}
//               />
//               <DropdownWithLabel
//                 label="Class"
//                 optionsData={chapterData}
//                 selected={selectedChapters}
//                 setSelected={setSelectedChapters}
//               />
//               <DropdownWithLabel
//                 label="Difficulty Level"
//                 optionsData={chapterData}
//                 selected={selectedChapters}
//                 setSelected={setSelectedChapters}
//               />
//             </div>
//             <div className="col-cs">
//               <DropdownWithLabel
//                 label="Course"
//                 optionsData={chapterData}
//                 selected={selectedChapters}
//                 setSelected={setSelectedChapters}
//               />
//               <DropdownWithLabel
//                 label="Chapter"
//                 optionsData={chapterData}
//                 selected={selectedChapters}
//                 setSelected={setSelectedChapters}
//               />
//               <div
//                 style={{
//                   marginTop: "40px",
//                   display: "flex",
//                   alignItems: "center",
//                 }}
//               >
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     marginRight: "10px",
//                   }}
//                 >
//                   <input
//                     style={{ height: "18px", width: "18px" }}
//                     type="checkbox"
//                     name=""
//                     id=""
//                   />
//                   <label style={{ marginLeft: "10px" }}>Important</label>
//                 </div>
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     marginRight: "10px",
//                   }}
//                 >
//                   <input
//                     style={{ height: "18px", width: "18px" }}
//                     type="checkbox"
//                     name=""
//                     id=""
//                   />
//                   <label style={{ marginLeft: "10px" }} htmlFor="">
//                     NCERT
//                   </label>
//                 </div>
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     marginRight: "10px",
//                   }}
//                 >
//                   <input
//                     style={{ height: "18px", width: "18px" }}
//                     type="checkbox"
//                     name=""
//                     id=""
//                   />
//                   <label style={{ marginLeft: "10px" }} htmlFor="">
//                     PYQ
//                   </label>
//                 </div>
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     marginRight: "10px",
//                   }}
//                 >
//                   <input
//                     style={{ height: "18px", width: "18px" }}
//                     type="checkbox"
//                     name=""
//                     id=""
//                   />
//                   <label style={{ marginLeft: "10px" }} htmlFor="">
//                     CBSE
//                   </label>
//                 </div>
//               </div>
//             </div>
//             <div className="col-cs">
//               <DropdownWithLabel
//                 label="Subject"
//                 optionsData={chapterData}
//                 selected={selectedChapters}
//                 setSelected={setSelectedChapters}
//               />
//               <DropdownWithLabel
//                 label="Topic"
//                 optionsData={chapterData}
//                 selected={selectedChapters}
//                 setSelected={setSelectedChapters}
//               />
//             </div>
//           </div>
//         </div>

//         <div
//           style={{
//             marginTop: "15px",
//             width: "82vw",
//             height: "30px",
//             fontWeight: "600",
//             backgroundColor: "#D6D6D6",
//             alignContent: "center",
//             paddingLeft: "8px",
//             boxShadow: "4px 4px 4px 0px #00000040",
//             border: "1px solid lightgrey",
//           }}
//         >
//           <label style={{ color: "#424342" }} htmlFor="">
//             Question
//           </label>
//         </div>
//         <div
//           style={{
//             backgroundColor: "#FBFBFB",
//             width: "82vw",
//             height: "auto",
//             boxShadow: "4px 4px 4px 0px #00000040",
//             color: "#424342",
//             padding: "10px",
//             marginBottom: "20px",
//             border: "1px solid lightgrey",
//           }}
//         >

//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: "15px",
//             }}
//           >
//           <TextboxWithImage questionCounter={questionCounter} />
//           {/* {renderInnerFields()} */}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default POP2;

// import React, { useEffect, useState } from "react";

// const TEST_URL = "https://dseinfotech.s3.amazonaws.com/dev/coaching_collab/question_bank/QID30021_IMG1_image4.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAUFB5JPBWXZQVSMVD%2F20250816%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20250816T140007Z&X-Amz-Expires=21600&X-Amz-SignedHeaders=host&X-Amz-Signature=d4686043c31e34e10f2b78b0cdf977061083f7a68a693907f9e13a31f11ea6b7";

// function isPresignedExpired(url) {
//   try {
//     const u = new URL(url);
//     const date = u.searchParams.get("X-Amz-Date");
//     const expires = Number(u.searchParams.get("X-Amz-Expires") || "0");
//     if (!date || !expires) return false;
//     const issued = Date.UTC(
//       Number(date.slice(0, 4)),
//       Number(date.slice(4, 6)) - 1,
//       Number(date.slice(6, 8)),
//       Number(date.slice(9, 11)),
//       Number(date.slice(11, 13)),
//       Number(date.slice(13, 15))
//     );
//     return Date.now() > (issued + expires * 1000);
//   } catch {
//     return false;
//   }
// }

// function fetchWithTimeout(url, ms = 15000) {
//   return Promise.race([
//     fetch(url, { method: "GET" }), // important: no extra headers
//     new Promise((_, reject) => setTimeout(() => reject(new Error("Timeout")), ms)),
//   ]);
// }

// function blobToBase64(blob) {
//   return new Promise((resolve, reject) => {
//     const r = new FileReader();
//     r.onerror = () => reject(new Error("FileReader failed"));
//     r.onloadend = () => resolve(r.result);
//     r.readAsDataURL(blob);
//   });
// }

// export default function S3FetchToBase64Test() {
//   const [status, setStatus] = useState("idle");
//   const [error, setError] = useState("");
//   const [info, setInfo] = useState(null);
//   const [dataUrl, setDataUrl] = useState("");

//   useEffect(() => {
//     (async () => {
//       setStatus("checking");
//       setError("");
//       setInfo(null);
//       setDataUrl("");

//       if (isPresignedExpired(TEST_URL)) {
//         setStatus("error");
//         setError("URL appears expired based on X-Amz-Date/X-Amz-Expires.");
//         return;
//       }

//       try {
//         setStatus("fetching");
//         const res = await fetchWithTimeout(TEST_URL, 15000);
//         const contentType = res.headers.get("content-type") || "unknown";
//         const blob = await res.blob();

//         setInfo({
//           ok: res.ok,
//           status: res.status,
//           contentType,
//           size: blob.size,
//         });

//         if (!res.ok) {
//           setStatus("error");
//           setError(`HTTP ${res.status} fetching image`);
//           return;
//         }

//         setStatus("converting");
//         const b64 = await blobToBase64(blob);
//         setDataUrl(b64);
//         setStatus("done");
//       } catch (e) {
//         setStatus("error");
//         setError(e.message || "Fetch failed");
//       }
//     })();
//   }, []);

//   return (
//     <div style={{ padding: 16, fontFamily: "system-ui, Arial" }}>
//       <h3>S3 presigned fetch → base64 test</h3>
//       <div><b>Status:</b> {status}</div>
//       {error && <div style={{ color: "red" }}><b>Error:</b> {error}</div>}
//       {info && (
//         <div style={{ marginTop: 8 }}>
//           <b>HTTP:</b> {info.ok ? "OK" : "Not OK"} | status={info.status} | type={info.contentType} | size={info.size} bytes
//         </div>
//       )}
//       {dataUrl && status === "done" && (
//         <div style={{ marginTop: 12 }}>
//           <div><b>Preview:</b></div>
//           <img src={dataUrl} alt="converted" style={{ maxWidth: 320, border: "1px solid #ccc" }} />
//           <details style={{ marginTop: 8 }}>
//             <summary>Show base64</summary>
//             <textarea readOnly value={dataUrl} style={{ width: "100%", height: 120, fontFamily: "monospace" }} />
//           </details>
//         </div>
//       )}
//     </div>
//   );
// }

// import React, { useEffect } from "react";
// import "mathlive"; // Import MathLive library

// const PhysicsLiveComponent = ({ onLatexChange }) => {
//   useEffect(() => {
//     const mathField = document.getElementById("physicsmathfield");

//     if (mathField) {
//       // Configure MathLive for physics
//       mathField.setOptions({
//         // Enable physics-friendly features
//         smartFence: true,
//         smartSuperscript: true,
//         scriptDepth: [Infinity, Infinity],
//         removeExtraneousParentheses: false,

//         // Custom macros for physics
//         macros: {
//           // Vectors
//           "\\vec": "\\overrightarrow{#1}",
//           "\\uvec": "\\hat{#1}",
//           "\\magnitude": "\\left|#1\\right|",

//           // Physics units
//           "\\meter": "\\text{m}",
//           "\\second": "\\text{s}",
//           "\\kilogram": "\\text{kg}",
//           "\\ampere": "\\text{A}",
//           "\\kelvin": "\\text{K}",
//           "\\mole": "\\text{mol}",
//           "\\candela": "\\text{cd}",

//           // Common physics symbols
//           "\\velocity": "v",
//           "\\acceleration": "a",
//           "\\force": "F",
//           "\\mass": "m",
//           "\\energy": "E",
//           "\\power": "P",
//           "\\voltage": "V",
//           "\\current": "I",
//           "\\resistance": "R",
//           "\\frequency": "f",
//           "\\wavelength": "\\lambda",
//           "\\planck": "h",
//           "\\boltzmann": "k_B",
//           "\\avogadro": "N_A",
//           "\\lightspeed": "c",
//         },
//       });

//       // Configure the virtual keyboard container
//       window.mathVirtualKeyboard.container = document.getElementById("physicskeyboardcontainer");

//       // Custom keyboard layouts for physics
//       window.mathVirtualKeyboard.layouts = [
//         {
//           label: "Physics Basic",
//           layers: [
//             {
//               rows: [
//                 [
//                   { latex: "F", tooltip: "Force" },
//                   { latex: "m", tooltip: "Mass" },
//                   { latex: "a", tooltip: "Acceleration" },
//                   { latex: "v", tooltip: "Velocity" },
//                   { latex: "t", tooltip: "Time" },
//                   { latex: "d", tooltip: "Distance" },
//                   { latex: "s", tooltip: "Displacement" },
//                 ],
//                 [
//                   { latex: "E", tooltip: "Energy" },
//                   { latex: "P", tooltip: "Power/Pressure" },
//                   { latex: "W", tooltip: "Work" },
//                   { latex: "K", tooltip: "Kinetic Energy" },
//                   { latex: "U", tooltip: "Potential Energy" },
//                   { latex: "Q", tooltip: "Heat/Charge" },
//                   { latex: "T", tooltip: "Temperature" },
//                 ],
//                 [
//                   { latex: "V", tooltip: "Voltage/Volume" },
//                   { latex: "I", tooltip: "Current" },
//                   { latex: "R", tooltip: "Resistance" },
//                   { latex: "C", tooltip: "Capacitance" },
//                   { latex: "L", tooltip: "Inductance" },
//                   { latex: "B", tooltip: "Magnetic Field" },
//                   { latex: "\\Phi", tooltip: "Magnetic Flux" },
//                 ]
//               ]
//             }
//           ]
//         },
//         {
//           label: "Vectors",
//           layers: [
//             {
//               rows: [
//                 [
//                   { latex: "\\vec{F}", tooltip: "Force Vector" },
//                   { latex: "\\vec{v}", tooltip: "Velocity Vector" },
//                   { latex: "\\vec{a}", tooltip: "Acceleration Vector" },
//                   { latex: "\\vec{r}", tooltip: "Position Vector" },
//                   { latex: "\\vec{p}", tooltip: "Momentum Vector" },
//                 ],
//                 [
//                   { latex: "\\hat{i}", tooltip: "Unit Vector i" },
//                   { latex: "\\hat{j}", tooltip: "Unit Vector j" },
//                   { latex: "\\hat{k}", tooltip: "Unit Vector k" },
//                   { latex: "\\hat{n}", tooltip: "Unit Normal Vector" },
//                   { latex: "\\hat{r}", tooltip: "Unit Radial Vector" },
//                 ],
//                 [
//                   { latex: "\\vec{A} \\cdot \\vec{B}", tooltip: "Dot Product" },
//                   { latex: "\\vec{A} \\times \\vec{B}", tooltip: "Cross Product" },
//                   { latex: "\\left|\\vec{A}\\right|", tooltip: "Vector Magnitude" },
//                   { latex: "\\nabla", tooltip: "Gradient" },
//                   { latex: "\\nabla \\cdot", tooltip: "Divergence" },
//                   { latex: "\\nabla \\times", tooltip: "Curl" },
//                 ]
//               ]
//             }
//           ]
//         },
//         {
//           label: "Greek Letters",
//           layers: [
//             {
//               rows: [
//                 [
//                   { latex: "\\alpha", tooltip: "Alpha" },
//                   { latex: "\\beta", tooltip: "Beta" },
//                   { latex: "\\gamma", tooltip: "Gamma" },
//                   { latex: "\\delta", tooltip: "Delta" },
//                   { latex: "\\epsilon", tooltip: "Epsilon" },
//                   { latex: "\\zeta", tooltip: "Zeta" },
//                 ],
//                 [
//                   { latex: "\\eta", tooltip: "Eta" },
//                   { latex: "\\theta", tooltip: "Theta" },
//                   { latex: "\\iota", tooltip: "Iota" },
//                   { latex: "\\kappa", tooltip: "Kappa" },
//                   { latex: "\\lambda", tooltip: "Lambda" },
//                   { latex: "\\mu", tooltip: "Mu" },
//                 ],
//                 [
//                   { latex: "\\nu", tooltip: "Nu" },
//                   { latex: "\\xi", tooltip: "Xi" },
//                   { latex: "\\pi", tooltip: "Pi" },
//                   { latex: "\\rho", tooltip: "Rho" },
//                   { latex: "\\sigma", tooltip: "Sigma" },
//                   { latex: "\\tau", tooltip: "Tau" },
//                 ],
//                 [
//                   { latex: "\\upsilon", tooltip: "Upsilon" },
//                   { latex: "\\phi", tooltip: "Phi" },
//                   { latex: "\\chi", tooltip: "Chi" },
//                   { latex: "\\psi", tooltip: "Psi" },
//                   { latex: "\\omega", tooltip: "Omega" },
//                   { latex: "\\Omega", tooltip: "Capital Omega" },
//                 ]
//               ]
//             }
//           ]
//         },
//         {
//           label: "Constants & Units",
//           layers: [
//             {
//               rows: [
//                 [
//                   { latex: "c", tooltip: "Speed of Light" },
//                   { latex: "h", tooltip: "Planck's Constant" },
//                   { latex: "\\hbar", tooltip: "Reduced Planck's Constant" },
//                   { latex: "k_B", tooltip: "Boltzmann Constant" },
//                   { latex: "N_A", tooltip: "Avogadro's Number" },
//                 ],
//                 [
//                   { latex: "e", tooltip: "Elementary Charge" },
//                   { latex: "\\epsilon_0", tooltip: "Permittivity of Free Space" },
//                   { latex: "\\mu_0", tooltip: "Permeability of Free Space" },
//                   { latex: "G", tooltip: "Gravitational Constant" },
//                   { latex: "g", tooltip: "Acceleration due to Gravity" },
//                 ],
//                 [
//                   { latex: "\\text{m}", tooltip: "Meter" },
//                   { latex: "\\text{kg}", tooltip: "Kilogram" },
//                   { latex: "\\text{s}", tooltip: "Second" },
//                   { latex: "\\text{A}", tooltip: "Ampere" },
//                   { latex: "\\text{K}", tooltip: "Kelvin" },
//                 ],
//                 [
//                   { latex: "\\text{N}", tooltip: "Newton" },
//                   { latex: "\\text{J}", tooltip: "Joule" },
//                   { latex: "\\text{W}", tooltip: "Watt" },
//                   { latex: "\\text{V}", tooltip: "Volt" },
//                   { latex: "\\text{Hz}", tooltip: "Hertz" },
//                 ]
//               ]
//             }
//           ]
//         },
//         {
//           label: "Operators",
//           layers: [
//             {
//               rows: [
//                 [
//                   { latex: "\\frac{\\partial}{\\partial x}", tooltip: "Partial Derivative" },
//                   { latex: "\\frac{d}{dt}", tooltip: "Time Derivative" },
//                   { latex: "\\int", tooltip: "Integral" },
//                   { latex: "\\oint", tooltip: "Closed Integral" },
//                   { latex: "\\sum", tooltip: "Summation" },
//                 ],
//                 [
//                   { latex: "\\sin", tooltip: "Sine" },
//                   { latex: "\\cos", tooltip: "Cosine" },
//                   { latex: "\\tan", tooltip: "Tangent" },
//                   { latex: "\\ln", tooltip: "Natural Logarithm" },
//                   { latex: "\\log", tooltip: "Logarithm" },
//                 ],
//                 [
//                   { latex: "\\exp", tooltip: "Exponential" },
//                   { latex: "\\sqrt{}", tooltip: "Square Root" },
//                   { latex: "x^2", tooltip: "Square" },
//                   { latex: "x^{-1}", tooltip: "Inverse" },
//                   { latex: "\\pm", tooltip: "Plus-Minus" },
//                 ],
//                 [
//                   { latex: "\\approx", tooltip: "Approximately Equal" },
//                   { latex: "\\propto", tooltip: "Proportional To" },
//                   { latex: "\\ll", tooltip: "Much Less Than" },
//                   { latex: "\\gg", tooltip: "Much Greater Than" },
//                   { latex: "\\infty", tooltip: "Infinity" },
//                 ]
//               ]
//             }
//           ]
//         }
//       ];

//       // Show the virtual keyboard
//       window.mathVirtualKeyboard.show();

//       // Add input event listener
//       mathField.addEventListener("input", () => {
//         const latex = mathField.getValue("latex");
//         if (onLatexChange) {
//           onLatexChange(latex); // Pass the updated LaTeX to the parent
//         }
//       });

//       // Cleanup function
//       return () => {
//         window.mathVirtualKeyboard.hide();
//       };
//     }
//   }, [onLatexChange]);

//   return (
//     <div>
//       <div style={{ marginBottom: "10px" }}>
//         <h3>Physics Calculator</h3>
//         <p style={{ fontSize: "12px", color: "#666" }}>
//           Use the keyboard below to input physics equations, vectors, and symbols
//         </p>
//       </div>

//       <math-field
//         id="physicsmathfield"
//         style={{
//           width: "100%",
//           minHeight: "60px",
//           border: "1px solid #ccc",
//           borderRadius: "4px",
//           padding: "8px",
//           fontSize: "18px"
//         }}
//         placeholder="Enter physics equations here..."
//       ></math-field>

//       <div
//         id="physicskeyboardcontainer"
//         style={{
//           height: "400px",
//           width: "100%",
//           marginTop: "10px",
//           border: "1px solid #ddd",
//           borderRadius: "4px",
//           backgroundColor: "#f9f9f9"
//         }}
//       ></div>
//     </div>
//   );
// };

// export default PhysicsLiveComponent;

// import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import Colors from "../../Constants/Colors";
// import InputComponent from "../CreateQuestionsPaper/TestScheduling/Input-testscheduling";
// import EndPoints from "../../Api/EndPoints";
// import { GET, POST, PUT } from "../../Api/HttpsMethods";
// import TablewithCross from "../../Components/TableComponent/TableForUserEdit";
// import DropDown from "../CreateQuestionsPaper/DppScheduling/ReflectDropdownClassic";
// import InputComponent2 from "../../Components/InputComponents/InputComponent";
// import DropDownWithPaginationAndSearch from "../../Components/DropDowns/DropdwonWithPagination";
// import MinusImg from "../../Assets/Images/CommanImages/MinusGrey.png";
// import { use } from "react";
// import { useNavigate } from "react-router-dom";
// import ErrorImg from "../../Assets/Images/CommanImages/Error.png";
// import SuccessImg from "../../Assets/Images/CommanImages/success.png";
// import InterogativeImg from "../../Assets/Images/CommanImages/Interogative.png";
// import useFieldChangeTracker from "./pop3";
// const UserEditFromDashboard = ({
//   dataClient,
//   messageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   setMessageBox,
// }) => {
//   console.log("DataClient prop:", dataClient);
//   const [employeeData, setEmployeeData] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [userNameForShow, setUserNameForShow] = useState("");
//   const [appAccess, setAppAccess] = useState("");
//   const [status, setStatus] = useState("");
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [UserStatus, setUserStatus] = useState("");
//   const location = useLocation();
//   // Inside component
//   const navigate = useNavigate();

//   const [showConfirmDialog, setShowConfirmDialog] = useState(false);
//   const [confirmAction, setConfirmAction] = useState(null);
//   const [confirmMessage, setConfirmMessage] = useState("");

//   useEffect(() => {
//     if (dataClient) {
//       const userName =
//         dataClient?.client_schema_name?.[6]?.[0]?.user_name || "";
//       const clientBranchId =
//         dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
//       const clientId =
//         dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;

//       // Store values in sessionStorage
//       sessionStorage.setItem("user_name", userName);
//       sessionStorage.setItem("clientBranchId", clientBranchId);
//       sessionStorage.setItem("clientId", clientId);
//     }
//   }, [dataClient]);
//   const ModifierUser =
//     dataClient?.client_schema_name?.[6]?.[0]?.user_name ||
//     sessionStorage.getItem("user_name") ||
//     "";

//   const clientBranchId =
//     dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id ||
//     sessionStorage.getItem("clientBranchId") ||
//     "";

//   const clientId =
//     dataClient?.client_schema_name?.[6]?.[0]?.client_id ||
//     localStorage.getItem("clientId") ||
//     sessionStorage.getItem("clientId");
//   const [RoleNamesForShow, setRoleNamesForShow] = useState([]);

//   const UserId = new URLSearchParams(location.search).get("UserID") || "";

//   const ConfirmDialog = ({ isOpen, message, onConfirm, onCancel }) => {
//     if (!isOpen) return null;

//     return (
//       <div
//         style={{
//           position: "fixed",
//           top: 0,
//           left: 0,
//           right: 0,
//           bottom: 0,
//           backgroundColor: "rgba(0, 0, 0, 0.5)",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           zIndex: 10,
//         }}
//       >
//         <div
//           style={{
//             backgroundColor: "white",
//             padding: "30px",
//             borderRadius: "8px",
//             boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.2)",
//             minWidth: "400px",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               width: "100%",
//             }}
//           >
//             <h3 style={{ margin: 0, color: "#2F2E40", textAlign: "left" }}>
//               {message}
//             </h3>
//             <div style={{ display: "flex", gap: "15px", marginLeft: "20px" }}>
//               <button
//                 className="create-test-section-btn"
//                 onClick={onConfirm}
//                 style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
//               >
//                 OK
//               </button>
//               <button
//                 className="create-test-section-btn"
//                 onClick={onCancel}
//                 style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
//               >
//                 CANCEL
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     const usernameFromUrl = params.get("UsernameOfEmployee");
//     if (usernameFromUrl) {
//       setUserNameForShow(usernameFromUrl);
//     }
//   }, [location.search]);

//   const [sampleHeaders, setSampleHeaders] = useState([]);
//   const [assignedRoles, setAssignedRoles] = useState([]);

//   const accessToken = localStorage.getItem("other");
//   const [allRoles, setAllRoles] = useState([]);
//   const [roleOptions, setRoleOptions] = useState([]);
//   const [selectedRole, setSelectedRole] = useState("");
//   // const [assignedRoles, setAssignedRoles] = useState([]);

//   const [userInfoVisible, setUserInfoVisible] = useState(true);
//   const [addRoleVisible, setAddRoleVisible] = useState(true);

//   const toggleUserInfoVisible = () => setUserInfoVisible((v) => !v);
//   const toggleAddRoleVisible = () => setAddRoleVisible((v) => !v);

//   // Remove table setters from fetchRoles
//   const fetchRoles = async () => {
//     try {
//       const response = await GET.noToken(EndPoints.GetRoles);
//       setAllRoles(response || []);
//       setRoleOptions(
//         Array.isArray(response)
//           ? response.map((role) => ({
//               label: role.role_name,
//               id: role.role_id.toString(),
//             }))
//           : []
//       );
//     } catch (err) {
//       console.error("Error fetching roles:", err);
//       alert("Failed to fetch roles from API");
//     }
//   };
//   const { trackChange, getChanges, resetChanges, updatedData } =
//     useFieldChangeTracker({
//       appAccess: appAccess,
//       assignedRoles: assignedRoles,
//     });

//   // Add this useEffect to see changes in console
//   useEffect(() => {
//     const changes = getChanges();
//     console.log("Current tracked changes:", changes);
//   }, [appAccess, assignedRoles]);
//   // In loadData, always set table headers/data from get-roles-by-user-id
//   const loadData = async () => {
//     try {
//       const rolesResp = await GET.withToken(
//         `${EndPoints.GetRolesByUserID}?user_id=${UserId}&client_id=${clientId}`
//       );

//       if (rolesResp?.data && rolesResp.table_data) {
//         const headers = rolesResp.data.map((str) => str.split("*")[1]);
//         setSampleHeaders(headers);

//         const tableData = Array.isArray(rolesResp.table_data)
//           ? rolesResp.table_data
//           : [];
//         setAssignedRoles(tableData);

//         // Extract Role Name column index
//         const roleNameIndex = headers.indexOf("Role name");

//         // Create array of role names only
//         const RoleNamesForShow = tableData
//           .map((row) => row[roleNameIndex])
//           .filter(Boolean);

//         // Set this to state
//         setRoleNamesForShow(RoleNamesForShow); // Declare state accordingly
//       }

//       // AllRoles and roleOptions for dropdown, do not set table from here!
//       const allRolesResp = await GET.noToken(EndPoints.GetRoles);
//       setAllRoles(Array.isArray(allRolesResp) ? allRolesResp : []);
//       setRoleOptions(
//         Array.isArray(allRolesResp)
//           ? allRolesResp.map((role) => ({
//               label: role.role_name,
//               id: role.role_id.toString(),
//             }))
//           : []
//       );
//     } catch (error) {
//       console.error("Error loading roles", error);
//     }
//   };

//   useEffect(() => {
//     if (UserId) {
//       loadData();
//     }
//   }, [UserId]);

//   const appAccessOptions = [
//     { label: "Web Portal", id: "Web Portal" },
//     { label: "Mobile Application", id: "Mobile Application" },
//     { label: "Both", id: "Both" },
//   ];

//   const renderQuestionText = (text) => {
//     if (!text) return "";
//     return text;
//   };

//   const renderQuestionTextModel = (text) => {
//     if (!text) return "";
//     return text;
//   };

//   const handleEyeClick = (questionId) => {
//     console.log("Eye clicked for question:", questionId);
//   };

//   const getSearchKeyFromUrl = () => {
//     const searchParams = new URLSearchParams(location.search);
//     return searchParams.get("MNTQuestionNumbers");
//   };

//   // Modify getAppAccessValue to accept both flags
//   const getAppAccessValue = (appUserValue, webUserValue) => {
//     if (appUserValue === 1 && webUserValue === 1) {
//       return "Both";
//     }
//     if (appUserValue === 1 && webUserValue !== 1) {
//       return "Mobile Application";
//     }
//     if (webUserValue === 1 && appUserValue !== 1) {
//       return "Web Portal";
//     }
//     return ""; // default fallback
//   };

//   const handleEditClick = () => {
//     setIsEditMode(true);
//   };

//   const roleIdIndex = sampleHeaders.indexOf("Role id");

//   const roleIdsForPayload = assignedRoles.map((row) => row[roleIdIndex]);

//   const handleSaveClick = async () => {
//     try {
//       console.log("Saving data:", {
//         appAccess,
//         status,
//         assignedRoles,
//         selectedRows,
//       });

//       const roleIdIndex = sampleHeaders.indexOf("Role id");
//       const roleIdsForPayload = assignedRoles.map((row) => row[roleIdIndex]);
//       const ResetFlagForSave = 1;
//       // Prepare flags based on appAccess string
//       let webUserFlag = 0;
//       let appUserFlag = 0;

//       if (appAccess === "Both") {
//         webUserFlag = 1;
//         appUserFlag = 1;
//       } else if (appAccess === "Mobile Application") {
//         webUserFlag = 0;
//         appUserFlag = 1;
//       } else if (appAccess === "Web Portal") {
//         webUserFlag = 1;
//         appUserFlag = 0;
//       }

//       // Prepare URL with query params including dynamic flags
//       // const url = `${EndPoints.UpdateUser}?username=${userNameForShow}&modified_by=${ModifierUser}&web_user_flag=${webUserFlag}&app_user_flag=${appUserFlag}&reset_password_flag=${ResetFlagForSave}`;
//       const url = `${EndPoints.UpdateUser}?username=${userNameForShow}&modified_by=${ModifierUser}&web_user_flag=${webUserFlag}&app_user_flag=${appUserFlag}`;

//       // Use your PUT.withToken method to make the PUT API call
//       const result = await PUT.withToken(url, roleIdsForPayload);

//       if (!result) {
//         throw new Error("Save failed");
//       }
//       if (result.status === 200) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>{result?.message || "User Data Updated successfully"}</span>
//             </div>
//           </div>
//         );
//         setActiveImg(SuccessImg);
//         setIsMessageBoxVisible(true);

//         setTimeout(() => {
//           setIsMessageBoxVisible(false);
//           navigate(-1);
//         }, 1500);
//       } else {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>{result?.message || "User Data Could not Update"}</span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorImg);
//         setIsMessageBoxVisible(true);
//       }
//     } catch (err) {
//       console.error("Error saving data:", err);
//       alert("Failed to save data");
//     }
//   };

//   const handleCancelClick = () => {
//     navigate(-1);
//   };

//   // first api should add loading here i think ? not sure currently
//   const fetchEmployeeData = async (searchKey) => {
//     try {
//       setLoading(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Loading employee data...</span>
//           </div>
//         </div>
//       );
//       setActiveImg(SuccessImg);
//       setIsMessageBoxVisible(true);

//       const url = `${EndPoints.GetEmployeeBySearchKey}?search_key=${searchKey}`;
//       const data = await GET.noToken(url);

//       if (data && data.length > 0) {
//         setEmployeeData(data[0]);
//         // setUserName(data[0].user_name || "");
//         setAppAccess(getAppAccessValue(data[0].app_user, data[0].web_user));
//         setStatus(data[0].status || "");
//         setUserStatus(data[0].user_status || "");
//         // setUserId(data[0].user_id || "");
//       } else {
//         setError("No employee data found");
//       }
//     } catch (err) {
//       setError(`Failed to fetch employee data: ${err.message}`);
//       console.error("Error fetching employee data:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     // console.log("Component mounted - fetching roles");
//     fetchRoles();
//   }, []);

//   useEffect(() => {
//     const searchKey = getSearchKeyFromUrl();
//     if (searchKey) {
//       fetchEmployeeData(searchKey);
//     } else {
//       setError("No search key found in URL");
//       setLoading(false);
//     }
//   }, [location.search]);

//   if (error) {
//     return (
//       <div style={{ color: "red", textAlign: "center", padding: "50px" }}>
//         Error: {error}
//       </div>
//     );
//   }

//   // When editing and adding a role:
//   const handleRoleSelection = (roleId) => {
//     setSelectedRole(roleId);
//     const roleObj = allRoles.find((r) => r.role_id.toString() === roleId);
//     if (!roleObj) return;

//     // Check if role already exists in assignedRoles
//     const roleIdIndex = sampleHeaders.indexOf("Role id");
//     const roleAlreadyExists = assignedRoles.some(
//       (row) => row[roleIdIndex]?.toString() === roleId
//     );

//     if (roleAlreadyExists) {
//       // Show error message in messagebox
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>This role is already added to the user.</span>
//           </div>
//         </div>
//       );
//       setActiveImg(ErrorImg);
//       setIsMessageBoxVisible(true);

//       // Auto-hide message after 2 seconds
//       setTimeout(() => {
//         setIsMessageBoxVisible(false);
//       }, 2000);

//       // Reset selected role
//       setSelectedRole("");
//       return;
//     }

//     // Set headers first if they don't exist
//     if (sampleHeaders.length === 0) {
//       const defaultHeaders = [
//         "Role id",
//         "Role code",
//         "Role name",
//         "Role description",
//         "Client id",
//         "Status",
//         "Last modified date",
//         "Last modified by",
//         "Create date",
//         "Created by",
//         "Last modified screen id",
//         "Client branch id",
//       ];
//       setSampleHeaders(defaultHeaders);
//     }

//     // Create the new row data
//     const newRow = [
//       roleObj.role_id,
//       roleObj.role_code,
//       roleObj.role_name,
//       roleObj.role_desc,
//       roleObj.client_id || "",
//       roleObj.status === 1 ? "Active" : "Inactive",
//       roleObj.last_modified_date || "",
//       roleObj.last_modified_by || "",
//       roleObj.create_date || "",
//       roleObj.created_by || "",
//       roleObj.last_modified_screen_id || "",
//       roleObj.client_branch_id || "",
//     ];

//     // Update the assigned roles with the new row
//     setAssignedRoles((prevRoles) => {
//       const updatedRoles = [...(prevRoles || []), newRow];
//       return updatedRoles;
//     });

//     // Reset selected role
//     setSelectedRole("");
//   };

//   const handleStatusToggleClick = () => {
//     const action = UserStatus === "Inactive" ? "activate" : "deactivate";
//     const actionCapitalized =
//       UserStatus === "Inactive" ? "Activate" : "Deactivate";

//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             width: "100%",
//           }}
//         >
//           <div style={{ display: "flex", gap: "15px" }}>
//             <div className="loader-tc"></div>
//             <span style={{ textAlign: "left", flex: "1" }}>
//               Are you sure you want to {action} this user?
//             </span>
//           </div>

//           <div style={{ display: "flex", gap: "15px" }}>
//             <button
//               className="create-test-section-btn-v3"
//               onClick={executeStatusToggle}
//               style={{
//                 boxShadow: "0px 4px 4px 0px #00000040",
//               }}
//             >
//               OK
//             </button>
//             <button
//               className="create-test-section-btn-v3"
//               onClick={handleCancelConfirmation}
//               style={{
//                 boxShadow: "0px 4px 4px 0px #00000040",
//               }}
//             >
//               CANCEL
//             </button>
//           </div>
//         </div>
//       </div>
//     );

//     setActiveImg(InterogativeImg);
//     setIsMessageBoxVisible(true);
//   };

//   const executeStatusToggle = async () => {
//     // Close the confirmation messagebox
//     setIsMessageBoxVisible(false);

//     // Show loading message
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>Processing...</span>
//         </div>
//       </div>
//     );
//     setActiveImg(SuccessImg);
//     setIsMessageBoxVisible(true);

//     try {
//       const flag = UserStatus === "Inactive" ? 1 : 0;
//       const url = `${EndPoints.ActivateDeactivateUser}?username=${userNameForShow}&client_id=${clientId}&flag=${flag}&modified_by=${ModifierUser}`;

//       const response = await fetch(url, {
//         method: "PATCH",
//         headers: {
//           accept: "application/json",
//           Authorization: `Bearer ${accessToken}`,
//         },
//       });

//       if (!response.ok) {
//         throw new Error(
//           `Failed to ${flag === 1 ? "activate" : "deactivate"} user: ${
//             response.status
//           }`
//         );
//       }

//       const result = await response.json();

//       if (result.status === 200) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>
//                 {result?.message ||
//                   `User ${
//                     flag === 1 ? "activated" : "deactivated"
//                   } successfully`}
//               </span>
//             </div>
//           </div>
//         );
//         setActiveImg(SuccessImg);
//         setIsMessageBoxVisible(true);

//         setTimeout(() => {
//           setIsMessageBoxVisible(false);
//           navigate(-1);
//         }, 1500);
//       } else {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>{result?.message || "User not Updated"}</span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorImg);
//         setIsMessageBoxVisible(true);
//       }
//     } catch (err) {
//       console.error("Error toggling user status:", err);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>
//               {`Failed to ${
//                 UserStatus === "Inactive" ? "activate" : "deactivate"
//               } user`}
//             </span>
//           </div>
//         </div>
//       );
//       setActiveImg(ErrorImg);
//       setIsMessageBoxVisible(true);
//     }
//   };

//   const handleCancelConfirmation = () => {
//     setIsMessageBoxVisible(false);
//   };

//   const handleResetPassword = () => {
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             width: "100%",
//           }}
//         >
//           <div style={{ display: "flex", gap: "15px" }}>
//             <div className="loader-tc"></div>
//             <span style={{ textAlign: "left", flex: "1" }}>
//               Are you sure you want to reset the password for this user?
//             </span>
//           </div>

//           <div style={{ display: "flex", gap: "15px" }}>
//             <button
//               className="create-test-section-btn-v3"
//               onClick={executeResetPassword}
//               style={{
//                 boxShadow: "0px 4px 4px 0px #00000040",
//               }}
//             >
//               OK
//             </button>
//             <button
//               className="create-test-section-btn-v3"
//               onClick={handleCancelConfirmation}
//               style={{
//                 boxShadow: "0px 4px 4px 0px #00000040",
//               }}
//             >
//               CANCEL
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//     setActiveImg(InterogativeImg);
//     setIsMessageBoxVisible(true);
//   };

//   const executeResetPassword = async () => {
//     // Close the confirmation messagebox
//     setIsMessageBoxVisible(false);

//     // Show loading message
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>Processing password reset...</span>
//         </div>
//       </div>
//     );
//     setActiveImg(SuccessImg);
//     setIsMessageBoxVisible(true);

//     try {
//       if (!userNameForShow || !ModifierUser) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>User information not available for password reset.</span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorImg);
//         setIsMessageBoxVisible(true);
//         return;
//       }

//       const url = `${EndPoints.UpdateUser}?username=${userNameForShow}&modified_by=${ModifierUser}&reset_password_flag=1`;

//       const response = await fetch(url, {
//         method: "PUT",
//         headers: {
//           accept: "application/json",
//           Authorization: `Bearer ${accessToken}`,
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify([]),
//       });

//       if (!response.ok) {
//         throw new Error(`Reset password failed with status ${response.status}`);
//       }

//       const result = await response.json();

//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{result?.message || "Password reset successfully!"}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(SuccessImg);
//       setIsMessageBoxVisible(true);

//       setTimeout(() => {
//         setIsMessageBoxVisible(false);
//       }, 2000);
//     } catch (error) {
//       console.error("Error resetting password:", error);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{`Password reset failed: ${error.message}`}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(ErrorImg);
//       setIsMessageBoxVisible(true);
//     }
//   };

//   // This function removes a row by its Role ID (row[0])
//   const handleDeleteRow = (rowId) => {
//     setAssignedRoles((prev) => prev.filter((row) => row[0] !== rowId));
//   };

//   // console.log("roleIdsForPayload" + roleIdsForPayload);
//   return (
//     <div className="Leftmargin-Main-DIV">
//       <div
//         style={{
//           position: "sticky",
//           top: 0,
//           backgroundColor: "white",
//           zIndex: 100,
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             marginBottom: "20px",
//             width: "98%",
//           }}
//         >
//           <div
//             style={{
//               fontSize: "30px",
//               color: `${Colors.color1}`,
//               fontWeight: "400",
//             }}
//           >
//             Application User Details
//           </div>
//           <div>
//             <div className="row-cs-uni">
//               <button
//                 className="create-test-section-btn"
//                 style={{
//                   marginRight: "18px",
//                   boxShadow: "0px 4px 4px 0px #00000040",
//                 }}
//                 onClick={handleCancelClick}
//               >
//                 CANCEL
//               </button>

//               <button
//                 className="create-test-section-btn"
//                 style={{
//                   marginRight: "18px",
//                   boxShadow: "0px 4px 4px 0px #00000040",
//                   // backgroundColor: "#d32f2f",
//                   // color: "white",
//                   width: "150px",
//                   //Password reset done sucessfully message show
//                 }}
//                 onClick={handleResetPassword} // Add this line
//               >
//                 RESET PASSWORD
//               </button>

//               <button
//                 className="create-test-section-btn"
//                 style={{
//                   marginRight: "18px",
//                   boxShadow: "0px 4px 4px 0px #00000040",
//                 }}
//                 onClick={handleStatusToggleClick}
//               >
//                 {UserStatus === "Inactive" ? "ACTIVATE" : "DEACTIVATE"}
//               </button>

//               {!isEditMode ? (
//                 <button
//                   className="create-test-section-btn"
//                   style={{ marginRight: "0px" }}
//                   onClick={handleEditClick}
//                 >
//                   EDIT
//                 </button>
//               ) : (
//                 <button
//                   className="create-test-section-btn"
//                   style={{ marginRight: "0px" }}
//                   onClick={handleSaveClick}
//                 >
//                   SAVE
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       <div
//         className="Header-1-C424342"
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           padding: "5px",
//         }}
//       >
//         <span>USER INFORMATION</span>
//         {userInfoVisible ? (
//           <img
//             src={MinusImg}
//             alt="Toggle"
//             style={{ cursor: "pointer", width: "24px", height: "10px" }}
//             onClick={toggleUserInfoVisible}
//           />
//         ) : (
//           <div
//             className="plus"
//             style={{
//               cursor: "pointer",
//               fontSize: "28px",
//               width: "24px",
//               height: "24px",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               color: "#888",
//               fontWeight: "bold",
//             }}
//             onClick={toggleUserInfoVisible}
//           >
//             +
//           </div>
//         )}
//       </div>

//       {userInfoVisible && (
//         <div className="Body-1-C424342" style={{ paddingBottom: "10px" }}>
//           <div className="row-cs-uni">
//             <div className="col-cs-uni">
//               <InputComponent2
//                 label="User Name"
//                 value={userNameForShow}
//                 // onChange={(e) => setUserName(e.target.value)}
//                 style={{ width: "95%" }}
//                 isRequired={false}
//                 // disable={!isEditMode}
//                 disable={true}
//               />
//             </div>

//             <div className="col-cs-uni">
//               <InputComponent
//                 label="Employee Name"
//                 value={`${employeeData.emp_first_name || ""} ${
//                   employeeData.emp_middle_name || ""
//                 } ${employeeData.emp_last_name || ""}`.trim()}
//                 style={{ width: "95%" }}
//                 isRequired={false}
//                 disable={true}
//               />
//             </div>

//             <div className="col-cs-uni">
//               <InputComponent
//                 label="Employee ID"
//                 value={employeeData.staff_number || ""}
//                 style={{ width: "95%" }}
//                 isRequired={false}
//                 disable={true}
//               />
//             </div>
//           </div>

//           <div className="row-cs-uni">
//             <div className="col-cs-uni">
//               <InputComponent
//                 label="Department"
//                 value={employeeData.department || ""}
//                 style={{ width: "95%" }}
//                 isRequired={false}
//                 disable={true}
//               />
//             </div>

//             <div className="col-cs-uni">
//               <InputComponent
//                 label="Designation"
//                 value={employeeData.designation || ""}
//                 style={{ width: "95%" }}
//                 isRequired={false}
//                 disable={true}
//               />
//             </div>

//             <div className="col-cs-uni">
//               <InputComponent
//                 label="Manager Name"
//                 value={employeeData.manager_name || "Not Assigned"}
//                 style={{ width: "95%" }}
//                 isRequired={false}
//                 disable={true}
//               />
//             </div>
//           </div>

//           <div className="row-cs-uni">
//             <div className="col-cs-uni">
//               <InputComponent
//                 label="User Status"
//                 value={UserStatus || ""}
//                 style={{ width: "95%" }}
//                 isRequired={false}
//                 disable={true}
//               />
//             </div>

//             <div className="col-cs-uni">
//               {!isEditMode ? (
//                 <InputComponent
//                   label="Application Access"
//                   value={appAccess || "Not Set"}
//                   style={{ width: "95%" }}
//                   isRequired={false}
//                   disable={true}
//                 />
//               ) : (
//                 <DropDown
//                   label="Application Access"
//                   style={{ width: "95%" }}
//                   setSelected={setAppAccess}
//                   selected={appAccess}
//                   options={appAccessOptions}
//                   isRequired={true}
//                 />
//               )}
//             </div>

//             <div className="col-cs-uni">
//               <InputComponent
//                 label="Approved by"
//                 value={employeeData.approved_by || ""}
//                 style={{ width: "95%" }}
//                 isRequired={false}
//                 disable={true}
//               />
//             </div>
//           </div>
//         </div>
//       )}
//       <div
//         className="Header-1-C424342"
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           padding: "5px",
//           marginTop: "30px",
//         }}
//       >
//         <span>ADD ROLE</span>
//         {addRoleVisible ? (
//           <img
//             src={MinusImg}
//             alt="Toggle"
//             style={{ cursor: "pointer", width: "24px", height: "10px" }}
//             onClick={toggleAddRoleVisible}
//           />
//         ) : (
//           <div
//             className="plus"
//             style={{
//               cursor: "pointer",
//               fontSize: "28px",
//               width: "24px",
//               height: "24px",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               color: "#888",
//               fontWeight: "bold",
//             }}
//             onClick={toggleAddRoleVisible}
//           >
//             +
//           </div>
//         )}
//       </div>

//       {addRoleVisible && (
//         <div className="Body-1-C424342" style={{ marginBottom: "50px" }}>
//           <div style={{ width: "32%" }}>
//             {!isEditMode ? (
//               <InputComponent
//                 label="Selected Roles"
//                 value={RoleNamesForShow.join(", ") || "None"}
//                 style={{ width: "99%" }}
//                 isRequired={false}
//                 disable={true}
//               />
//             ) : (
//               <DropDownWithPaginationAndSearch
//                 label="Select Role"
//                 selected={selectedRole}
//                 setSelected={handleRoleSelection}
//                 options={roleOptions}
//                 style={{ width: "99%" }}
//                 isRequired={false}
//                 itemsPerPage={4} // ✅ Configure items per page
//               />
//             )}
//           </div>
//           <TablewithCross
//             headers={sampleHeaders}
//             data={assignedRoles}
//             searchPlaceholder="Search roles..."
//             selectedRows={selectedRows}
//             setSelectedRows={setSelectedRows}
//             renderQuestionText={renderQuestionText}
//             renderQuestionTextModel={renderQuestionTextModel}
//             expandedStates={{}}
//             toggleImage={() => {}}
//             handleEyeClick={handleEyeClick}
//             pageType="userEdit"
//             onRowLinkClick={(row) => console.log("Row clicked:", row)}
//             filterConfig={{}}
//             handleDeleteRow={handleDeleteRow}
//           />
//         </div>
//       )}

//       <ConfirmDialog
//         isOpen={showConfirmDialog}
//         message={confirmMessage}
//         onConfirm={confirmAction}
//         onCancel={handleCancelConfirmation}
//       />
//     </div>
//   );
// };

// export default UserEditFromDashboard;

import React, { useState, useEffect } from "react";
import useFieldChangeTracker from "./pop3"; // Import the updated hook

const Pop2 = () => {
  // Options for the selector dropdown
  const roleOptions = [
    { value: "admin", label: "Administrator" },
    { value: "user", label: "Regular User" },
    { value: "moderator", label: "Moderator" },
    { value: "guest", label: "Guest" },
  ];

  // Initial data format (object) - This will be captured on component mount
  const [initialData, setInitialData] = useState({
    UserName: "JohnDoe",
    Email: "email@.com",
    Role: " ",
  });

  // Current/changed data - managed by local state
  const [currentData, setCurrentData] = useState({
    UserName: "JohnDoe",
    Email: "email@.com",
    Role: " ",
  });

  // ✅ UPDATED: Audit configuration with correct API parameters
  const auditConfig = {
    clientBranchId: 1,
    screenId: "007",
    userName:
      localStorage.getItem("userName") ||
      sessionStorage.getItem("userName") ||
      "TestUser",
  };

  // Use the field change tracker hook
  const { saveAuditWithData, getChanges, resetChanges } = useFieldChangeTracker(
    initialData,
    auditConfig
  );

  // Capture initial data on component mount (simulate data fetch)
  useEffect(() => {
    // Simulate fetching data from API
    const fetchedData = {
      UserName: "JohnDoe",
      Email: "email@.com",
      Role: "user",
    };

    setInitialData(fetchedData);
    setCurrentData(fetchedData);

    // Store initial data in sessionStorage for persistence
    sessionStorage.setItem("pop2InitialData", JSON.stringify(fetchedData));
  }, []);

  // Handler for input changes
  const handleUserNameChange = (e) => {
    setCurrentData((prev) => ({
      ...prev,
      UserName: e.target.value,
    }));
  };

  const handleEmailChange = (e) => {
    setCurrentData((prev) => ({
      ...prev,
      Email: e.target.value,
    }));
  };

  // Handler for selector/dropdown change
  const handleRoleChange = (e) => {
    setCurrentData((prev) => ({
      ...prev,
      Role: e.target.value,
    }));
  };

  // Handler to show changes (for debugging)
  const handleShowChanges = () => {
    const storedInitialData = sessionStorage.getItem("pop2InitialData");
    const initialDataSnapshot = storedInitialData
      ? JSON.parse(storedInitialData)
      : initialData;

    // Compare and show changes
    const allKeys = new Set([
      ...Object.keys(initialDataSnapshot),
      ...Object.keys(currentData),
    ]);

    const changes = [];
    allKeys.forEach((key) => {
      if (initialDataSnapshot[key] !== currentData[key]) {
        changes.push({
          field: key,
          oldValue: initialDataSnapshot[key],
          newValue: currentData[key],
        });
      }
    });

    // console.log("Changes detected:", changes);
    // console.log("Audit Config:", auditConfig); // Log audit config for verification
    alert(JSON.stringify(changes, null, 2));
  };

  // Handler to save changes and send audit trail
  const handleSaveChanges = async () => {
    // Get initial data from sessionStorage
    const storedInitialData = sessionStorage.getItem("pop2InitialData");
    const initialDataSnapshot = storedInitialData
      ? JSON.parse(storedInitialData)
      : initialData;

    // Current data snapshot
    const currentDataSnapshot = currentData;

    // console.log("📦 Initial Data:", initialDataSnapshot);
    // console.log("📦 Current Data:", currentDataSnapshot);
    // console.log("📦 Audit Config:", auditConfig);

    // Save audit trail
    const result = await saveAuditWithData(
      initialDataSnapshot,
      currentDataSnapshot
    );

    if (result.success) {
      alert("✅ Changes saved and audit trail recorded successfully!");

      // Update initial data to current data after successful save
      setInitialData(currentData);
      sessionStorage.setItem("pop2InitialData", JSON.stringify(currentData));

      console.log("✅ Audit saved:", result);
    } else {
      alert(`❌ Error saving audit trail: ${result.message}`);
      console.error("❌ Audit error:", result);
    }
  };

  // Handler to reset changes (revert to initial data)
  const handleResetChanges = () => {
    const storedInitialData = sessionStorage.getItem("pop2InitialData");
    const initialDataSnapshot = storedInitialData
      ? JSON.parse(storedInitialData)
      : initialData;

    setCurrentData(initialDataSnapshot);
    resetChanges();
    console.log("Changes reset to initial data!");
  };

  // Check if there are changes
  const hasChanges =
    JSON.stringify(initialData) !== JSON.stringify(currentData);

  // Get the label for the selected role
  const getSelectedRoleLabel = (roleValue) => {
    const role = roleOptions.find((opt) => opt.value === roleValue);
    return role ? role.label : roleValue;
  };

  return (
    <div style={{ padding: "20px", maxWidth: "1500px", margin: "0 auto" }}>
      <h2>Field Change Tracker Demo with Audit Trail</h2>

      {/* Display audit config for verification */}
      <div
        style={{
          marginBottom: "20px",
          padding: "10px",
          backgroundColor: "#e7f3ff",
          border: "1px solid #2196F3",
          borderRadius: "4px",
        }}
      >
        <strong>📋 Audit Configuration:</strong>
        <pre style={{ margin: "5px 0 0 0", fontSize: "12px" }}>
          {JSON.stringify(auditConfig, null, 2)}
        </pre>
      </div>

      <div style={{ marginBottom: "15px" }}>
        <label>
          <strong>UserName:</strong>
          <input
            type="text"
            value={currentData.UserName}
            onChange={handleUserNameChange}
            style={{
              marginLeft: "10px",
              padding: "8px",
              
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
        </label>
      </div>

      <div style={{ marginBottom: "15px" }}>
        <label>
          <strong>Email:</strong>
          <input
            type="email"
            value={currentData.Email}
            onChange={handleEmailChange}
            style={{
              marginLeft: "10px",
              padding: "8px",
              
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
        </label>
      </div>

      <div style={{ marginBottom: "15px" }}>
        <label>
          <strong>Role:</strong>
          <select
            value={currentData.Role}
            onChange={handleRoleChange}
            style={{
              marginLeft: "10px",
              padding: "8px",
              
              border: "1px solid #ccc",
              borderRadius: "4px",
              backgroundColor: "white",
              cursor: "pointer",
            }}
          >
            {roleOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>
      </div>

      <div style={{ marginTop: "20px", display: "flex", gap: "10px" }}>
        <button
          onClick={handleShowChanges}
          style={{
            padding: "10px 15px",
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Show Changes
        </button>

        <button
          onClick={handleSaveChanges}
          disabled={!hasChanges}
          style={{
            padding: "10px 15px",
            backgroundColor: hasChanges ? "#28a745" : "#ccc",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: hasChanges ? "pointer" : "not-allowed",
          }}
        >
          Save & Audit
        </button>

        <button
          onClick={handleResetChanges}
          disabled={!hasChanges}
          style={{
            padding: "10px 15px",
            backgroundColor: hasChanges ? "#dc3545" : "#ccc",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: hasChanges ? "pointer" : "not-allowed",
          }}
        >
          Reset Changes
        </button>
      </div>

      {hasChanges && (
        <div
          style={{
            marginTop: "20px",
            padding: "10px",
            backgroundColor: "#fff3cd",
            border: "1px solid #ffc107",
            borderRadius: "4px",
          }}
        >
          <strong> Unsaved Changes Detected Lets go -----------</strong>
        </div>
      )}

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{ marginTop: "20px" }}>
          <h3>Initial Data:</h3>
          <pre
            style={{
              backgroundColor: "#f8f9fa",
              padding: "10px",
              borderRadius: "4px",
              border: "1px solid #dee2e6",
              width:"700px"
            }}
          >
            {JSON.stringify(
              {
                ...initialData,
                RoleLabel: getSelectedRoleLabel(initialData.Role),
              },
              null,
              2
            )}
          </pre>
        </div>

        <div style={{ marginTop: "20px" }}>
          <h3>Current Data:</h3>
          <pre
            style={{
              backgroundColor: "#f8f9fa",
              padding: "10px",
              borderRadius: "4px",
              border: "1px solid #dee2e6",
               width:"700px"
            }}
          >
            {JSON.stringify(
              {
                ...currentData,
                RoleLabel: getSelectedRoleLabel(currentData.Role),
              },
              null,
              2
            )}
          </pre>
        </div>
      </div>
    </div>
  );
};

export default Pop2;









// User DATA : id , token , 
// Page Subject Phy 